import Icon from '../../components/bases/icone/icon';

import AppBase from '../appBase';
import AppSettings from './appcomponents/appsettings/appsettings';
import AppMediaAssets from './appcomponents/appmediaassets/appmediaassets.js';
import AppHeader from './appcomponents/appheader/appheader.js';

import VideoPlayerTr from '../../components/bases/videoplayer/videoplayertr.js';
import ApplyOffsetVideo from '../dialogs/applyoffsetvideo.js';
import SpeakersList from './appcomponents/speakerslist/speakerslist.js';
import SequencesBlock from './appcomponents/sequences/sequenceblock.js';
import TimeLine from './appcomponents/timeline/timeline';
import Zoom from './appcomponents/timeline/zoom/zoom.js';
import ToolsBar from '../../components/bases/toolsbar/toolsbar';
import User from "./appcomponents/user/user.js"
import SimplePopup from '../../components/bases/popup/simplePopup.js';
import styles from "../appstyles/styles.module.css"
import { apiDeleteConfiguration, apiReadOneVideo, apiSaveUserConfig } from '../../utils/apis.js';
import { getVideoPath, getAudioPath,getCpPaths } from '../../utils/apis.js';
import { apiGetAllChildsSubtitleAssets, apiCreateFromAsset,apiReadOneAsset, apiSearchAssetsFromProject } from '../../utils/apis.js';
import { apiCreateSequences } from '../../utils/apis.js';
import { directDownloadTxt,directDownloadJson, directDownloadBinary } from '../../utils/download';
import {getStickyWordsList} from '../../utils/download';
import { keyboard_special_down, keyboard_special_up } from '../../utils/keyboard';

import { keyboard_multi_getKey, keyboard_multi_getShorCutList_by_apps_and_keyboard, keyboard_multi_savePersonnalKey } from '../../utils/keyboard_multi.js';
import { getCurrentModeTranscript, getCurrentUserDatas, getCurrentVersion, setCurrentModeTranscript, setCurrentUserDatas } from '../../utils/software.js';
import { getAssetColorsByType } from '../../utils/colors.js';
import {getCurrentProjectDatas} from "../../utils/software.js"
import { getlocalhostDatas } from '../../utils/apis.js';
import { createNewTimeCodesForTranscription, scriptRecomputeFromApp } from './appcomponents/utils.js';
import { UploadComponentRef, GlobalContext, SideBarRef } from '../../utils/globalprovider.js';

import { getSequenceVersionFile,createV2SequencesFiles, sequencesCreateDefaultSequenceV2 } from '../../utils/sequences.js';

import imgblue from "./assets/toolsbar/blue.png"
import imggreen from "./assets/toolsbar/green.png"
import imgcyan from "./assets/toolsbar/cyan.png"
import imgred from "./assets/toolsbar/red.png"
import imgmagenta from "./assets/toolsbar/magenta.png"
import imgyellow from "./assets/toolsbar/yellow.png"
import imgwhite from "./assets/toolsbar/white.png"

import imgsave from "./assets/toolsbar/save.png"

import imgcadenas from "./assets/toolsbar/cadenas.png"
import imgstabilo from "./assets/toolsbar/stabilo.png"
import imgdelchilds from "./assets/toolsbar/delchilds.png"
import imgtcmanual from "./assets/toolsbar/tcmanual64.png"

import imgnewst from "./assets/toolsbar/newst.png"
import imgcheckst from "./assets/toolsbar/checkst.png"

import imgsquencesplus from "./assets/toolsbar/sequences/sequencesplus.png"
import imgaddsequence from "./assets/toolsbar/sequences/addsequence.png"
import imgdeletesequenceafter from "./assets/toolsbar/sequences/deletesequenceafter.png"
import imgdeletesequencebefore from "./assets/toolsbar/sequences/deletesequencebefore.png"
import imgundosequence from "./assets/toolsbar/sequences/undosequence.png"


import imgdisplaytranscription from "./assets/toolsbar/display/transcription.png"
import imgdisplaysubtitles from "./assets/toolsbar/display/soustitres.png"
import imgdisplaytimeline from "./assets/toolsbar/display/timeline.png"
import imgdisplayplayer from "./assets/toolsbar/display/player.png"
import imgdisplayspeakers from "./assets/toolsbar/display/speakers.png"
import imgdisplaysequences from "./assets/toolsbar/display/sequences.png"


import imglayoutloaddefault from "./assets/toolsbar/layouts/layoutloaddefault.png"
import imglayoutload from "./assets/toolsbar/layouts/layoutload.png"
import imglayoutsave from "./assets/toolsbar/layouts/layoutsave.png"

import imgshortcuts from "./assets/toolsbar/shortcuts.png"
import imgaletter from "./assets/toolsbar/aletter.png"


import ftva from "../../assets/ftva.png"
import easytt from "../../assets/logoEasyTTSmall.png"



import Transcript from "./appcomponents/transcript/transcript"

import { getDefaultLayout, loadLayout, saveLayout } from '../../utils/software.js';
import { getStabiloForTranscriptApp, globalIsACp, globalAddCP, globalFindCpBefore, globalFindCpAfter } from '../../utils/checksubtitles.js';

import React from "react";
import CommonRaccourcis from './appcomponents/allsettings/commonraccourcis/commonraccourcis.js';
import CommonTableCaracteres from './appcomponents/allsettings/commontablecaracteres/commontablecaracteres.js';

import { configurations_framestotime, configurations_getDefaultParams, configurations_getDefaultPlayerParams, configurations_getDefaultTimeLineParams } from '../../utils/configurations.js';
import { V2_ConvertTimeCodeStringToSecond, V2_ConvertTimeCodeStringToSecondFromAsset, V2_ConvertSecondToTimeCodeStringFromAsset, V2_RoundedTimeCode } from '../../utils/timecodev2.js';

import { apiReadOneConfiguration, apiSetAssetConfiguration } from '../../utils/apis.js';

import { wait } from './appcomponents/transcript/utils/functions.js';

import { cloneDeep, isEqual, orderBy, times, uniqBy } from 'lodash';


class AppTranscription extends AppBase
{
    static contextType = GlobalContext;
    constructor (props)
    {
        super(props);
        const mode = getCurrentModeTranscript();
        

        var startstparams = configurations_getDefaultParams();
        startstparams.cplist = [];
        startstparams.cplistinverse = [];
        
        
        
        const user  = getCurrentUserDatas();
        var layout = [];

        
        switch (user.config.transcription.current)
        {
          case 0: layout = user.config.transcription.blocks.usine1; break;
          case 1: layout = user.config.transcription.blocks.usine2; break;
          case 2: layout = user.config.transcription.blocks.user1; break;
          case 3: layout = user.config.transcription.blocks.user2; break;
          case 4: layout = user.config.transcription.blocks.user3; break;
            
        }

        try
        {
          layout.forEach(block => {block.span = (<></>)});
          
        }
        catch(e)
        {
          
          
          layout = user.config.transcription.blocks.usine1;
          layout.forEach(block => {block.span = (<></>)});
        }
        this.state = {

          stparams: startstparams,          // paramètres modifiés de l'asset en cours
          defaultsparams: startstparams,    // parametres de la configuration de l'asset en cours
          refreshKey: this.getTimeHHMMSSforKey(),

          codatas: {coid: -1},


          popupText: "",
          deleteChildsAssetPopup: false,
          createANewTranscriptionPopup: false,
          deleteConsfigurationPopup: false,
          childsAssetList: [],

          modeA: mode.modeA,
          //blocks: getDefaultLayout("transcription",1),
          blocks: layout,
          
          action: { current:"none",
            },
          activeid: "",
          
          speakers: [],

          paramOpen: false,
          timelineHeight: 30,
          timelineHeightInPixel: 10,
          pjid: getCurrentProjectDatas().pjid,
          
          videopath: "", 
          videoready:false,
          videoforplayer: null,

          timecodeAsset:
          {
            asid:0,
            asframerate:25,
            asnum:25,
            asden:1,
            asdropframe:0,
            astimecode: "00:00:00:00",
          },

          currentTimeCodePlayer: 0,

          displayCommonRaccourcis: false,
          displayCommonTableCaracteres: false,
          displayApplyOffset: false,

          appInfos:
          {
              trDuree:0,
              trMots:0,
              trPhrase: 0,
              trLisMin: 0,
              trLisMinCP: 0,
              viNbCP: 0,

              stNb: 0,
              stLisM: 0,
              stLenM: 0,
              stDureeM : 0,

              stDecaleMax: 0,
              stDecaleMaxPos: 0,
              stDecaleM: 0,
          },

          
          
          transcriptReadOnly: false, 


          toolsbar:
          { 
            height: 20,


            families:[
                {
                    fr: "couleurs",
                    en: "colors",
                    items: [
                      {img: imgblue ,type:"button", disable:false,fr:"Bleu",en:"Blue", nochangecolor:true, key:{key:"BLUE", cat:"transcriptshortcut"}},
                      {img: imggreen ,type:"button", disable:false,fr:"Vert",en:"Green", nochangecolor:true, key:{key:"GREEN", cat:"transcriptshortcut"}},
                      {img: imgcyan ,type:"button", disable:false,fr:"Cyan",en:"Cyan", nochangecolor:true, key:{key:"CYAN", cat:"transcriptshortcut"}},
                      {img: imgred ,type:"button", disable:false,fr:"Rouge",en:"Red", nochangecolor:true, key:{key:"RED", cat:"transcriptshortcut"}},
                      {img: imgmagenta ,type:"button", disable:false,fr:"Magenta",en:"Magenta", nochangecolor:true, key:{key:"MAGENTA", cat:"transcriptshortcut"}},
                      {img: imgyellow ,type:"button", disable:false,fr:"Jaune",en:"Yellow", nochangecolor:true, key:{key:"YELLOW", cat:"transcriptshortcut"}},
                      {img: imgwhite ,type:"button", disable:false,fr:"Blanc",en:"White", nochangecolor:true, key:{key:"WHITE", cat:"transcriptshortcut"}},
                    ],
                },

                {
                    fr: "actions",
                    en: "actions",
                    items: [
                      {img: imgsave ,type:"button", disable:false,fr:"Sauvegarder",en:"Save", nochangecolor:false, key:{key:"SAVE", cat:"transcriptshortcut"}},
                      {img: imgcheckst ,type:"button", disable:false,fr:"A revoir",en:"To be checked", nochangecolor:false, key:{key:"CHECKWORD", cat:"transcriptshortcut"}},
                      {img: imgnewst ,type:"button", disable:false,fr:"Nouvelle ligne",en:"New line.", nochangecolor:false, key:{key:"NEWST", cat:"transcriptshortcut"}},
                      {img: imgdelchilds ,type:"button", disable:false,fr:"Supprimer les fichiers de sous-titres",en:"Delete subtitles files.", nochangecolor:false, key:{key:"DELCHILDS", cat:"transcriptshortcut"}},
                      {toogle: false,  img: imgtcmanual ,type:"button", disable:false,fr:"Définir nouveau timecode.",en:"Set new timecode", nochangecolor:false, key:{key:"TCMANUAL", cat:"mode"}},
                    ],
                },

              {
                    fr: "mode",
                    en: "mode",

                items: [
                  {toogle: true, value:mode.modeA, img: imgcadenas ,type:"button", disable:false,fr:"Faire suivre la vidéo",en:"Lock video", nochangecolor:false, key:{key:"LOCKVIDEO", cat:"mode"}},
                  {toogle: true, value:false, img: imgstabilo ,type:"button", disable:false,fr:"Afficher les mots en retard",en:"Display delayed words", nochangecolor:false, key:{key:"STABILO", cat:"mode"}},
                  

                ],
              },

                {
                      fr: "Affichage",
                      en: "Display",

                  items: [
                    {img: imgdisplayplayer ,type:"button", disable:false,fr:"Player",en:"Player", nochangecolor:false, key:{key:"player", cat:"display"}},
                    {img: imgdisplaytimeline ,type:"button", disable:false,fr:"TimeLine",en:"TimeLine", nochangecolor:false, key:{key:"timeline", cat:"display"}},
                    {img: imgdisplaytranscription ,type:"button", disable:false,fr:"Transcription",en:"Transcription", nochangecolor:false, key:{key:"transcription", cat:"display"}},
                    {img: imgdisplaysubtitles ,type:"button", disable:false,fr:"Sous-Titres",en:"Subtitles", nochangecolor:false, key:{key:"subtitles", cat:"display"}},
                    {img: imgdisplayspeakers ,type:"button", disable:false,fr:"Speakers",en:"Speakers", nochangecolor:false, key:{key:"speakers", cat:"display"}},
                    {img: imgdisplaysequences ,type:"button", disable:false,fr:"Séquences",en:"Sequences", nochangecolor:false, key:{key:"sequences", cat:"display"}},
                  ],
                },

                {
                  fr: 'Séquences',
                  en: 'Sequences',
                  items: [
                    { img: imgsquencesplus, type: "button", disable: false, fr: "Ajouter un asset de séquences", en: "Add sequences asset", nochangecolor: false, key: { key: "sequencesplus", cat: "sequences" } },
                    { img: imgaddsequence, type: "button", disable: true, fr: "Ajouter une séquence ici", en: "Add a sequence here", nochangecolor: false, key: { key: "addsequence", cat: "sequences" } },
                    { img: imgdeletesequencebefore, type: "button", disable: true, fr: "Supprimer et prolonger la séquence précédente", en: "Delete and extend the previous sequence", nochangecolor: false, key: { key: "deletesequencebefore", cat: "sequences" } },
                    { img: imgdeletesequenceafter, type: "button", disable: true, fr: "Supprimer et avancer la séquence suivante", en: "Delete and advance to the next sequence", nochangecolor: false, key: { key: "deletesequenceafter", cat: "sequences" } },
                    { img: imgundosequence, type: "button", disable: true, fr: "Undo (Séquences)", en: "Undo (Séquences)", nochangecolor: false, key: { key: "undosequence", cat: "sequences" } },
                  ]
                },

                
                {
                  fr: 'Divers',
                  en: 'Misc.',
                  items: [
                    { img: imgshortcuts, type: "button", disable: false, fr: "Modifier la programmation des touches", en: "Edit programming keys", nochangecolor: false, key: { key: "commonShortcuts", cat: "shortcuts" } },
                    { img: imgaletter, type: "button", disable: false, fr: "Afficher la table des caractères", en: "Display the character table", nochangecolor: false, key: { key: "commonCharacters", cat: "shortcuts" } },
                  ]
                },


                {
                      fr: "Présentations",
                      en: "Layouts",

                  items: [
                    {img: imglayoutloaddefault ,type:"button", disable:false,fr:"Charger présentation prédéfinie n°1",en:"Load predefined layout #1", nochangecolor:true, key:{key:"loaddef1", cat:"layouts"}},
                    {img: imglayoutloaddefault ,type:"button", disable:false,fr:"Charger présentation prédéfinie n°2",en:"Load predefined layout #2", nochangecolor:true, key:{key:"loaddef2", cat:"layouts"}},
                    {type:"space"},
                    {img: imglayoutload,type:"button", disable:false,fr:"Charger présentation utilisateur n° 1",en:"Load personnal layout #1", nochangecolor:true, key:{key:"load1", cat:"layouts"}},
                    {img: imglayoutload,type:"button", disable:false,fr:"Charger présentation utilisateur n° 2",en:"Load personnal layout #2", nochangecolor:true, key:{key:"load2", cat:"layouts"}},
                    {img: imglayoutload,type:"button", disable:false,fr:"Charger présentation utilisateur n° 3",en:"Load personnal layout #3", nochangecolor:true, key:{key:"load3", cat:"layouts"}},
                    {type:"space"},
                    {img: imglayoutsave,type:"button", disable:false,fr:"Sauvegarder présentation utilisateur n° 1",en:"Save personnal layout #1", nochangecolor:true, key:{key:"save1", cat:"layouts"}},
                    {img: imglayoutsave,type:"button", disable:false,fr:"Sauvegarder présentation utilisateur n° 2",en:"Save personnal layout #2", nochangecolor:true, key:{key:"save2", cat:"layouts"}},
                    {img: imglayoutsave,type:"button", disable:false,fr:"Sauvegarder présentation utilisateur n° 3",en:"Save personnal layout #3", nochangecolor:true, key:{key:"save3", cat:"layouts"}},


                  ],
              },        
              
            
            ]

          }
        }

        this.languageToolUrl = 'https://dico.easydirect.fr/';

        this.shortcuts_list = [];

      this.containerBlockRef = React.createRef();
      this.commonRaccourcisRef = React.createRef();
      this.commonTableCaracteresRef = React.createRef();


        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.onCancelKeyboardEvent = this.onCancelKeyboardEvent.bind(this);
        this.cancelKeyboardEvent = false;
        this.onNewTime = this.onNewTime.bind(this);
        this.handleOnMustReload = this.handleOnMustReload.bind(this);
        this.handleEndApplyVideo = this.handleEndApplyVideo.bind(this)
        this.VideoReady = this.VideoReady.bind(this);

        this.onClickToolsBar = this.onClickToolsBar.bind(this);
        this.onClickCommonRaccourcis = this.onClickCommonRaccourcis.bind(this);
        this.onClickCommonTableCaracteres = this.onClickCommonTableCaracteres.bind(this);

        this.videoPlayerRef = React.createRef();
        this.bodyDivRef = React.createRef();
        this.assetsManagerRef = React.createRef();
        this.appMediaAssetsRef = React.createRef();

        this.toolsbarRef = React.createRef();

        // timeline
        this.onChangeTimeLineZoom = this.onChangeTimeLineZoom.bind(this)    
        this.state.zoomValue = 9;
        this.timelineRef = React.createRef();
        this.addcp = this.addcp.bind(this);
        this.handleCPFileLoaded = this.handleCPFileLoaded.bind(this);
        
        
        this.handleTimeLineWheel = this.handleTimeLineWheel.bind(this);
        this.handleGotoTime = this.handleGotoTime.bind(this);
        

        this.transcriptRef = React.createRef();
        this.divTranscriptRef = React.createRef();
        this.createOneUndo = this.createOneUndo.bind(this);
        // temporary
        
        this.OtherFilesdownloadDone = this.OtherFilesdownloadDone.bind(this)

       // Gestion des queues des raccourcis
      this.actionQueue = [];
      this.isProcessingAction = false;

      this.enqueueAction = this.enqueueAction.bind(this);
      this.processNextAction = this.processNextAction.bind(this);

        // transcription
        this.saveTranscription = this.saveTranscription.bind(this);
        this.autoSave = this.autoSave.bind(this)
        this.changeTranscription = this.changeTranscription.bind(this);
        this.onSwapTranscription = this.onSwapTranscription.bind(this);
        this.moveTranscription = this.moveTranscription.bind(this);
        this.onchangeparams = this.onchangeparams.bind(this);
        this.forceRecomputeFromTimeLine = this.forceRecomputeFromTimeLine.bind(this);
        this.TranscriptionisModified = false;
        this.onSaveDone = this.onSaveDone.bind(this)
        this.searchAllCpForTranscription = this.searchAllCpForTranscription.bind(this);
      
        // speakers
        this.state.speakers = [];
        this.state.speakerIdsOrderByAppearance = [];
        this.onChangeSpeakers = this.onChangeSpeakers.bind(this);
        this.onMergeSpeaker = this.onMergeSpeaker.bind(this);
        this.onIdentifySpeakerDialoguesClick = this.onIdentifySpeakerDialoguesClick.bind(this);

        // asset manager
        this.onClickOnAsset = this.onClickOnAsset.bind(this)
        this.onAssetsManagerChange = this.onAssetsManagerChange.bind(this)
        this.exitAllPopup = this.exitAllPopup.bind(this);
        this.onReallyDeleteChildsAsset = this.onReallyDeleteChildsAsset.bind(this);

        // app assets manager
        this.onAppMediaAssetsAction = this.onAppMediaAssetsAction.bind(this);


        // time line
        this.handleClickOnWaveForm = this.handleClickOnWaveForm.bind(this)


        // transcription worker
        this.motsc =""; // liste mots collants utf8 séparés par ";"
        this.transcriptWorker = null;
        this.currentComputedSubtilesSerialized = null;
        this.forceSave = false;
        this.displayDelay = false;

        this.state.playerparams = getCurrentUserDatas().config.transcription.player;
        this.state.currentplayerparams = getCurrentUserDatas().config.transcription.player;



        this.state.timelineparams = getCurrentUserDatas().config.transcription.timeline;
        this.currenttimelineparams = getCurrentUserDatas().config.transcription.timeline;

        // *********************************************************************************************************************
        // application params
        // *********************************************************************************************************************
        this.state.applicationsparams = getCurrentUserDatas().config.paramsapp;

        this.getTimeCodeString = this.getTimeCodeString.bind(this);
        

        this.appsettingsRef = React.createRef();

        // séquences
        this.sequences_createsequences = this.sequences_createsequences.bind(this);
        this.sequences_createsequences_callback = this.sequences_createsequences_callback.bind(this);
        this.sequences_setsequences_callback = this.sequences_setsequences_callback.bind(this);
        this.sequences_onGetText = this.sequences_onGetText.bind(this);
        this.doActionSequence = this.doActionSequence.bind(this)
        this.sequences_add_one_undo = this.sequences_add_one_undo.bind(this)
        
        this.sequences_onChangeSequences = this.sequences_onChangeSequences.bind(this);
        this.sequences_goto = this.sequences_goto.bind(this);
        this.onClickOnSequence = this.onClickOnSequence.bind(this);
        this.sequencesRef = React.createRef();
        
        this.initialised =  false;
        this.assetsList = [];
        this.currentOriginalTranscriptId = 0;
        this.currentCorrectedTranscriptId = 0;
        this.currentCalculedSubtitlesId = 0;
        this.currentSequencesId = 0;
        this.currentVideoId = 0;

        
        this.state.sequencesasset  = {asid:0, astitle:""};
        this.state.sequences = {sequences:[]};
        
        this.undosequences = [];
        this.maxUndoSequences = 10;

        
        this.onCreateANewTranscription = this.onCreateANewTranscription.bind(this)
        this.returnToMainPage = this.returnToMainPage.bind(this)
        this.restartRealoadPage = this.restartRealoadPage.bind(this)


        this.onReadAllChildSubtitleAssets = this.onReadAllChildSubtitleAssets.bind(this);


        this.V2_FirstassetsDownloaded =  false;

        this.V2_FirstDownloadProjectAssets  = this.V2_FirstDownloadProjectAssets.bind(this)
        this.V2_ExistAsset = this.V2_ExistAsset.bind(this)
        this.V2_CorrectedFromOriginal = this.V2_CorrectedFromOriginal.bind(this)
        this.V2_SearchFirstTranscriptionByType = this.V2_SearchFirstTranscriptionByType.bind(this)
        this.V2_OpenFirstTranscription = this.V2_OpenFirstTranscription.bind(this)
        this.V2_OpenTranscription = this.V2_OpenTranscription.bind(this)
        this.V2_SaveCurrentTranscription = this.V2_SaveCurrentTranscription.bind(this)
        this.V2_PrepareToOpenTranscription = this.V2_PrepareToOpenTranscription.bind(this)
        this.V2_apicallbackReadOriginal = this.V2_apicallbackReadOriginal.bind(this)
        this.V2_apicallbackReadCorrected = this.V2_apicallbackReadCorrected.bind(this)
        this.V2_apiCallBackCopyToNewCorrectedTranscription = this.V2_apiCallBackCopyToNewCorrectedTranscription.bind(this)
        this.V2_SetNewTranscriptionCorrected = this.V2_SetNewTranscriptionCorrected.bind(this)
        this.V2_onCreateNewStFileStDone = this.V2_onCreateNewStFileStDone.bind(this)
        this.V2_StartComputeFirstTimeSutbtitle = this.V2_StartComputeFirstTimeSutbtitle.bind(this)
        this.V2_ReadCorrectedSubtitlesCallBack = this.V2_ReadCorrectedSubtitlesCallBack.bind(this)
        
   
        this.V2_ComputeSubtitle = this.V2_ComputeSubtitle.bind(this)
        this.V2_LastTranscriptSubtileComputeSubtitle = 0; // Derniere transcription utilisé le pour calcul de sous-titre
        this.TranscriptionisModifiedForSubtitle = false; // transcription modifiée mais non calculé
        this.V2_ComputeSubtitleInProgress = false;
        this.V2_SaveSubtitleInProgress = false;

        this.apicallbackReadVideo = this.apicallbackReadVideo.bind(this)

        this.onReadVideoForCP = this.onReadVideoForCP.bind(this)
        this.onReadVideoForAudio1 = this.onReadVideoForAudio1.bind(this)
        this.onReadVideoForAudio2 = this.onReadVideoForAudio2.bind(this)

        this.onReadVideoForVideo = this.onReadVideoForVideo.bind(this)

        this.blocks_onMouseMove = this.blocks_onMouseMove.bind(this);
        this.blocks_onMouseUp = this.blocks_onMouseUp.bind(this);


        this.loadCurrentConfiguration = this.loadCurrentConfiguration.bind(this)
        this.loadCurrentConfigurationDone = this.loadCurrentConfigurationDone.bind(this);
        this.loadCurrentConfigurationFromAppMediaAsset = this.loadCurrentConfigurationFromAppMediaAsset.bind(this);
        this.loadCurrentConfigurationFromAppMediaAssetDone = this.loadCurrentConfigurationFromAppMediaAssetDone.bind(this);
        this.writeCurrentConfigurationInAsset = this.writeCurrentConfigurationInAsset.bind(this);
        this.writeCurrentConfigurationInAssetDone = this.writeCurrentConfigurationInAssetDone.bind(this);
        this.onDeleteConfiguration = this.onDeleteConfiguration.bind(this);
        this.onDeleteConfigurationDone = this.onDeleteConfigurationDone.bind(this);
        this.firstLoadConfiguration = this.firstLoadConfiguration.bind(this);
        this.firstLoadConfigurationDone = this.firstLoadConfigurationDone.bind(this);


      }  

    canClose()
    {
      if ((this.timelineRef) && (this.timelineRef.current))
      {
        if (this.timelineRef.current.getCPListToSave()) return false;
      }

      if ((this.sequencesRef) && (this.sequencesRef.current))
      {
        if (this.sequencesRef.current.getSequencesModified()) return false;
      }
      return !this.TranscriptionisModified;
      
    }

    getTimeCodeString(time) {
      return V2_ConvertSecondToTimeCodeStringFromAsset(time, this.state.timecodeAsset, this.state.playerparams.displaytcms);
    } 




  addcp(base64, timecode)
    {
        
  
        
        const cp = globalIsACp(timecode,this.state.stparams.cplist, 0.020);
        if (cp !== null)
        {
            this.state.stparams.cplist.splice(cp.index, 1);
            this.state.stparams.cplistinverse = this.state.stparams.cplist.slice().reverse();
            // on met à jour la tanscription
            this.upDateAllCpForTranscription();
            // la time line
            if ((this.timelineRef) && (this.timelineRef.current))
              this.timelineRef.current.setNewCPList(this.state.stparams.cplist);
  

            this.setState({stparams:this.state.stparams});
            this.forceRecomputeFromTimeLine();
            return;
        }
  
  
  
  
        const newcp = {
          offset:0, size:0, time:timecode, base64:base64, tc: this.getTimeCodeString(timecode),
        }
  
        if (this.timelineRef.current)
        {
            this.state.stparams.cplist = this.timelineRef.current.getCPList();
            this.state.stparams.cplistinverse = this.state.stparams.cplist.slice().reverse();
        }
  
        
        this.state.stparams.cplist = globalAddCP(this.state.stparams.cplist, newcp);
        
        this.state.stparams.cplistinverse = this.state.stparams.cplist.slice().reverse();
  
        
  
        // on met à jour la tanscription
        this.upDateAllCpForTranscription();
        // la time line
        if ((this.timelineRef) && (this.timelineRef.current))
          this.timelineRef.current.setNewCPList(this.state.stparams.cplist);

        this.setState({stparams:this.state.stparams});
  
        this.forceRecomputeFromTimeLine();
    }
  
  
  
  getCurrentDate = () => {
      const today = new Date();
    
      const year = today.getFullYear(); // Année AAAA
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (01-12)
      const day = String(today.getDate()).padStart(2, '0'); // Jour (01-31)
    
      return `${year}/${month}/${day}`;
    };
  generateUUID() 
  {
    const array = new Uint8Array(16);
    window.crypto.getRandomValues(array);

    array[6] = (array[6] & 0x0f) | 0x40; // Version 4
    array[8] = (array[8] & 0x3f) | 0x80; // Variant 1

    return [...array].map((byte, index) => {
        const hex = byte.toString(16).padStart(2, '0');
        return ([4, 6, 8, 10].includes(index) ? '-' : '') + hex;
    }).join('');
  }

    
    componentDidMount() 
    {


      this.shortcuts_list =keyboard_multi_getShorCutList_by_apps_and_keyboard(["player","transcription"]);
      

      window.addEventListener('keydown', this.handleKeyDown);
      window.addEventListener('keyup', this.handleKeyUp);
      this.startIntervalAutoSave();
      this.startIntervalComputeSubtitles();
      if (this.initialised) return;
      this.initialised = true;
        

      if ((this.timelineRef) && (this.timelineRef.current))
      {
          var h = this.timelineRef.current.createDefaultTimeLine();
  
          const containerHeight = this.bodyDivRef.current.clientHeight;
          const percentage = (h / containerHeight) * 100;
          this.setState({
              timelineHeight: percentage,
              timelineHeightInPixel: h,
          })

          
          this.timelineRef.current.setNewTimeLineSize(h);

      }

      
      
      this.downloadDefaultFiles();

      if (getCurrentProjectDatas().pjconfig > 0)
        this.firstLoadConfiguration(getCurrentProjectDatas().pjconfig);
      else
        this.V2_FirstDownloadProjectAssets(); // C'est parti


    }

    onSwapTranscription(corrected)
    {
      var id = this.currentOriginalTranscriptId;
        if (corrected) id = this.currentCorrectedTranscriptId;


      const asset = this.V2_GetAssetFromID(this.assetsList, id);
      if (!asset) return;
      this.state.blocks.forEach(block=>{
        if (block.id === "transcription")
        {

            var originale = (<></>)
            if ((asset.assubtype === 1) || (asset.assubtype === 2))
            {
              const ti = asset.assubtype===1?"Simp.":"Sce.";
              originale = (<>&nbsp;<span style={{borderStyle:"solid",borderColor:"gray",borderWidth:"1px",fontSize:"10px", paddingRight: "3px", paddingLeft: "3px", borderRadius: "3px", color:"white",backgroundColor:"black"}}>{ti}</span></>)
            }
            const colors = this.getCurrentValueByType(asset.astype);
            block.span = (<><span style={{fontSize:"10px", paddingRight: "3px", paddingLeft: "3px", borderRadius: "3px", color:colors.color,backgroundColor:colors.backcolor}}>{asset.asid}</span>&nbsp;{originale}&nbsp;{asset.astitle}</>);    

        }
      })

      this.setState({blocks:this.state.blocks})

    }

    //  **********************************************************************
    //  * Messages assets manager
    //  **********************************************************************

    onReadVideoForVideo(datas)
    {
        if (datas.length !==0)
        {
          const videofile = getVideoPath(datas[0]);
          

          const framerate = datas[0].viframerate.toFixed(2).replace('.', ','); // "1234,56"
          const num = datas[0].vinum;
          const den = datas[0].viden;
          const dropframe = datas[0].vidropframe;



          this.setState({videopath: videofile, 
            videoready: true, 
            timecodeAsset: datas[0],
            videoforplayer: datas[0]});


          
          this.onReadVideoForCP(datas);
          this.onReadVideoForAudio1(datas);
          this.onReadVideoForAudio2(datas)

          this.currentVideoId = datas[0].viid;
          if ((this.assetsManagerRef) && (this.assetsManagerRef.current))
          {
            this.assetsManagerRef.current.setNewCurrent(
              {
                  video: this.currentVideoId,
                  originaltr: this.currentOriginalTranscriptId,
                  correctedtr: this.currentCorrectedTranscriptId,
                  calculatedsubtitles: this.currentCalculedSubtitlesId,
                  correctedsubtitle: 0,
                  finaltr: 0,                    
                  sequences: this.currentSequencesId,
              }
            );
            this.assetsManagerRef.current.reloadAllAssets();
          }


        }

    }

    onReadVideoForCP(datas)
    {
      
      const cpfiles = getCpPaths(datas[0]);
      
      if ("json" in cpfiles)
      {
          
          
          const indextr = this.timelineRef.current.getIndexByType("mp4zcp");
          // on ajoute la piste de cp si elle n'existe pas
          if (indextr == -1)
          {
              
              if (this.currenttimelineparams.trtrackcp)
              {
                this.timelineRef.current.addTrack ("mp4zcp",datas[0], cpfiles.json,cpfiles.jpegs,0, datas[0].viid);
              }
              this.currenttimelineparams.trtrackcp = true;
              
          }
          else
            this.timelineRef.current.setNewDatas (indextr, cpfiles.json, datas[0].viid, cpfiles.jpegs);

          this.timelineRef.current.forceRecreate();
          if ((this.currenttimelineparams.trsmalltrackcp) &&
          (this.currenttimelineparams.trtrackcp))
            
          this.timelineRef.current.minimiseTrack("mp4zcp");

      }

    }
    onReadVideoForAudio1(datas)
    {
      const audiofile1 = getAudioPath(1, datas[0]);
      if (audiofile1 ==="") return;

      const indextr = this.timelineRef.current.getIndexByTypeAndChannel("mp4zaudio", 1);
      // on ajoute la piste de cp si elle n'existe pas
      if (indextr == -1)
        this.timelineRef.current.addTrack ("mp4zaudio",null, audiofile1,"",1, datas[0].viid);
      else
        this.timelineRef.current.setNewDatas (indextr, audiofile1, datas[0].viid);

        this.timelineRef.current.forceRecreate();

        
    }
    onReadVideoForAudio2(datas)
    {
      const audiofile2 = getAudioPath(2, datas[0]);
      if (audiofile2 ==="") return;

      const indextr = this.timelineRef.current.getIndexByTypeAndChannel("mp4zaudio", 2);
      // on ajoute la piste de cp si elle n'existe pas
      if (indextr == -1)
        this.timelineRef.current.addTrack ("mp4zaudio",null, audiofile2,"",2, datas[0].viid);
      else
        this.timelineRef.current.setNewDatas (indextr, audiofile2, datas[0].viid);

        this.timelineRef.current.forceRecreate();
      
    }


    onClickOnAsset(asset, type="")
    {
      
      
      if (this.V2_ComputeSubtitleInProgress) return;
      if (this.V2_SaveSubtitleInProgress) return;

      
      

      if (asset.astype == 3)
      {
        

        if (type === "")
          {
            if ((this.timelineRef) && (this.timelineRef.current))
            {

                  this.state.stparams = configurations_framestotime(this.state.stparams, asset.asnum, asset.asden, asset.asdropframe);
                  this.state.stparams.num = asset.asnum;
                  this.state.stparams.den = asset.asden;
                  this.state.stparams.dropframe = asset.asdropframe;
                  this.setState({stparams:  this.state.stparams});

                  apiReadOneVideo({viid: asset.asviid},this.onReadVideoForVideo);
            }
          }
  

        if (type === "cp")
        {
          if ((this.timelineRef) && (this.timelineRef.current))
          {
                apiReadOneVideo({viid: asset.asviid},this.onReadVideoForCP);
          }
        }
        if (type === "audio1")
          {
            if ((this.timelineRef) && (this.timelineRef.current))
            {
                  apiReadOneVideo({viid: asset.asviid},this.onReadVideoForAudio1);
            }
          }
          if (type === "audio2")
            {
              if ((this.timelineRef) && (this.timelineRef.current))
              {
                    apiReadOneVideo({viid: asset.asviid},this.onReadVideoForAudio2);
              }
            }
            return;
        }

      if (asset.astype === 8)
      {
        // à voir pour la sauvegarde des sequences
        this.sequences_save_sequences();
        this.sequences_setSequences(asset.asid);
        return;
      }
      

      if (asset.astype === 2) // on choisie une nouvelle transcription corrigée
      {
        if (this.currentCorrectedTranscriptId === asset.asid) 
        {
            // on regarde si on a encore le track transcription corrigée

            const indextr = this.timelineRef.current.getIndexByType("newtrjson");
            // on ajoute la piste de transcription si elle n'existe pas
            if (indextr == -1)
              this.timelineRef.current.addTrack ("newtrjson",this.transcriptRef.current.getTranscription(), "NEW","",0,this.currentCorrectedTranscriptId);
            return;
        }
        this.saveTranscription();
        this.V2_OpenTranscription (0,asset.asid,0)
        
        this.TranscriptionisModifiedForSubtitle = true;
      }

      if (asset.astype === 1) // on choisie une nouvelle transcription orginale
      {
        //ici


        
        if (this.currentOriginalTranscriptId === asset.asid) 
        {
            // on regarde si on a encore le track transcription originale
            const indextr = this.timelineRef.current.getIndexByType("trjson");
            // on ajoute la piste de transcription si elle n'existe pas
            if (indextr == -1)
            {
              
              this.timelineRef.current.addTrack ("trjson",this.transcriptRef.current.getOriginalTranscription(), "NEW","",0,this.currentOriginalTranscriptId);
            }
            return;
        }
        this.saveTranscription();
        this.V2_OpenTranscription (asset.asid,0,0)
        this.TranscriptionisModifiedForSubtitle = true;
      }
    }


    
    //  **********************************************************************
    //  * l'asset manager a rechargé sa liste d'assets
    //  **********************************************************************
    onAssetsManagerChange(datas)
    {

      this.assetsList = datas;
      
      
      
      if (this.currentOriginalTranscriptId > 0)
      {
          const asset = this.V2_GetAssetFromID(this.assetsList, this.currentOriginalTranscriptId);
          if (asset.asid > 0)
          {

              if ((this.transcriptRef) && (this.transcriptRef.current))
              {
                this.transcriptRef.current.setOriginalDescription(asset.astitle);
                
              }
          }
      }

      if (this.currentCorrectedTranscriptId > 0)
        {
            const asset = this.V2_GetAssetFromID(this.assetsList, this.currentCorrectedTranscriptId);
            if (asset.asid > 0)
            {
                if ((this.transcriptRef) && (this.transcriptRef.current))
                {
                  this.transcriptRef.current.setDescription(asset.astitle, asset.aslang);
                }
            }
        }
  

    }


    downloadDefaultFiles()
    {
        directDownloadTxt (getlocalhostDatas() + "fr/motscollants.txt",this.OtherFilesdownloadDone,"motsc") 
        directDownloadJson (getlocalhostDatas() + 'fr/common_errors_fra.json',this.OtherFilesdownloadDone,"commonerrors");

    }


    // Suppression de l'écouteur lorsque le composant est démonté
    componentWillUnmount() 
    {
      this.stopIntervalAutoSave();
      this.stopIntervalComputeSubtitle();
      window.removeEventListener('keydown', this.handleKeyDown);
      window.removeEventListener('keyup', this.handleKeyUp);
      if (this.transcriptWorker) this.transcriptWorker.terminate();
      this.transcriptWorker=null;
    }  
      


    // call back transcription
    saveTranscription()
    {
        if ((this.timelineRef) && (this.timelineRef.current))
        {
          if (this.timelineRef.current.getCPListToSave()) 
          {
            const datas = this.timelineRef.current.getCPListToSave();
            const infos =  this.timelineRef.current.getCPListToSaveFileInfos();

            
            const memoryFile = new File([datas], infos.datas.vixcpfile, 
                  {
                  type: "application/json", // MIME type for JSON
                  lastModified: new Date().getTime() // Timestamp for the file
                  });            
           
                if ((UploadComponentRef) && (UploadComponentRef.current))
                {
                  const formulaire = {

                    id: infos.id,
                    aspjid: this.state.pjid,
                    astype: 3,
                    uploadfile: memoryFile,
                    filenamedest: "videos/"+ infos.datas.vifile + "/" + infos.datas.vixcpfile +"_cp.json",
                    filenamesource: infos.datas.vixcpfile,
                    asupdatedate: this.getCurrentDate(),

                  }
                  
                  UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 4 ,null);
                  this.timelineRef.current.clearCPListToSave();
              
              }
          }
        }


        if ((this.sequencesRef) && (this.sequencesRef.current))
        {
          if (this.sequencesRef.current.getSequencesModified())
            this.sequences_save_sequences();
        }
        if (!this.TranscriptionisModified) 
          return;
        
        if ((this.transcriptRef) && (this.transcriptRef.current))
        {
          
          if (this.currentCorrectedTranscriptId <1 ) return;
          const id = this.transcriptRef.current.getId();
          
          if (id > 0)
          {
            const asset = this.V2_GetAssetFromID(this.assetsList, id)
            if (asset.asid === 0) return;

            
            var datas = {
              transcription: this.transcriptRef.current.getTranscription(),
              version: getCurrentVersion(),
              stparams: this.state.stparams,
              stats: this.state.appInfos,
              speakers: this.state.speakers,
              den: ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden),
              num: ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum),
              dropframe: ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.vidropframe:this.state.timecodeAsset.asdropframe),
              timecode: ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.vitimecode:this.state.timecodeAsset.astimecode),
            }

            datas = JSON.stringify(datas);



            const memoryFile = new File([datas], asset.asfile + "." +asset. asext, 
                  {
                  type: "application/json", // MIME type for JSON
                  lastModified: new Date().getTime() // Timestamp for the file
                  });            
            

            if ((UploadComponentRef) && (UploadComponentRef.current))
            {
              const formulaire = {
                asid: id,
                aspjid: this.state.pjid,
                astype: asset.astype,
                uploadfile: memoryFile,
                filenamedest: asset.asfile + "." +asset. asext,
                filenamesource: asset.asfile,
                asupdatedate: this.getCurrentDate(),
              }
             UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 2 ,this.onSaveDone);
              
            }

            // on fait la même chose avec le fichier de sous titre
            if ((!this.V2_ComputeSubtitleInProgress) && (this.currentCalculedSubtitlesId > 0))
            {

              
              const assetst = this.V2_GetAssetFromID(this.assetsList, this.currentCalculedSubtitlesId);
              if (assetst.asid > 0)
              {
                  if (this.currentComputedSubtilesSerialized !== null)
                  {
                    const memoryFileST = new File([this.currentComputedSubtilesSerialized], assetst.asfile + "." +assetst. asext, 
                      {
                      type: "application/json", // MIME type for JSON
                      lastModified: new Date().getTime() // Timestamp for the file
                      });            
                      if ((UploadComponentRef) && (UploadComponentRef.current))
                      {
                        const formulaire = {
                          asid: assetst.asid,
                          aspjid: this.state.pjid,
                          astype: 4,
                          uploadfile: memoryFileST,
                          filenamedest: assetst.asfile + "." +assetst.asext,
                          filenamesource: assetst.asfile,
                          asupdatedate: this.getCurrentDate(),
                          
                        }
                        UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 2 ,null);
                      }
                }
            }
          }
        }

    }
   }

    onSaveDone()
    {
        this.TranscriptionisModified = false;
    
    }
    //  *******************************************************************************************************
    //  intervalle auto save 
    //  *******************************************************************************************************
    startIntervalAutoSave() 
    {
      this.intervalIdAutoSave = setInterval(() => {

        // this.TranscriptionisModified = true;
        this.autoSave();
      }, 60000); 
      
    }
    
    stopIntervalAutoSave()
    {
      clearInterval(this.intervalIdAutoSave);
    }
    autoSave()
    {
        if (this.TranscriptionisModified) this.saveTranscription();
    }

    //  *******************************************************************************************************
    //  intervalle auto save 
    //  *******************************************************************************************************
    startIntervalComputeSubtitles() 
    {
      this.intervalIdComputeSubtitle = setInterval(() => {

        
        this.V2_ComputeSubtitle();
      }, 3000); 
    }
    
    stopIntervalComputeSubtitle()
    {
      clearInterval(this.intervalIdComputeSubtitle);
    }

    V2_ComputeSubtitle()
    {




        
        if (this.TranscriptionisModifiedForSubtitle)
        {
            
            this.TranscriptionisModifiedForSubtitle = false;

            
            
            
            if (this.V2_ComputeSubtitleInProgress) 
            {
              
              return;
            }
          
            

            if (this.currentCalculedSubtitlesId < 1 ) return; // pas de fichier pour l'instant
            if (this.currentCorrectedTranscriptId < 1 ) return; // pas de fichier pour l'instant

            
            const asset = this.V2_GetAssetFromID(this.assetsList, this.currentCalculedSubtitlesId)
            if (asset.asoriid !== this.currentCorrectedTranscriptId) 
            {
              
              return;
            }

            
            
            
            // récuperation des datas transcription
            if ((this.transcriptRef)&&(this.transcriptRef.current))
            {
              var transcription = this.transcriptRef.current.getTranscription();


              var cplist=[];
              var cplistinverse=[];

              

              

              
              if (this.timelineRef.current)
              {
                  cplist = this.timelineRef.current.getCPList();
                  cplistinverse = cplist.slice().reverse();
              }


              
              var stparams = cloneDeep(this.state.stparams);
              if (!("lisibilityMode" in stparams)) 
              {
                stparams = configurations_getDefaultParams();
              }
              this.setState ({stparams:stparams})

              /*
              if (!("lisibilityMode" in this.state.stparams)) 
              {
                this.state.stparams = configurations_getDefaultParams();
                
              }
              this.state.stparams.cplist = cplist;
              this.state.stparams.cplistinverse = cplistinverse;
              */
              
              
              var scriptptr = null;

              if (this.displayDelay)
              {
                var scriptptr = this.transcriptRef.current.getTranscriptionPtr();
                scriptptr.forEach(o => {
                  o["stabilo"] = 0;
                  o["stabiloColor"] = "#000000";
                });
              }

             
              


              const workerDatas  = 
                {newjson: transcription, 
                  motsc: this.motsc, 
                  stparams: stparams,
                  //stparams: this.state.stparams,
                  scriptptr: scriptptr,
                  num: "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum,
                  den: "viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden,
                  timecode: "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vitimecode:this.state.timecodeAsset.astimecode,
                  dropframe: "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vidropframe:this.state.timecodeAsset.asdropframe,
                };

              if (true)
              {
                
                try{
                  if (this.transcriptWorker)
                    this.transcriptWorker.terminate();
                  this.transcriptWorker=null;
                }
                catch(e)
                {
                  console.log("catch error terminate worker", e)
                }
                

                this.V2_ComputeSubtitleInProgress= true;
                this.transcriptWorker = new Worker(new URL('./transcriptworker.js', import.meta.url));
                this.transcriptWorker.postMessage(workerDatas);

                this.transcriptWorker.onerror = (event) => {
                  console.error('Worker error:', event.message);
                  console.error('Filename:', event.filename);
                  console.error('Line:', event.lineno);
                  console.error('Column:', event.colno);
                  
                  console.error('Error object:', event.error);
                };    
                
                
                
                this.transcriptWorker.onmessage = (e) => {
                      if (this.displayDelay)
                      {
                          // on stabilote 
                        var scriptptr = this.transcriptRef.current.getTranscriptionPtr();
                        const lastst = e.data.st.length - 1;

                        e.data.st.forEach( (st, indexst) =>
                        {
                          // on recherche le premier mot affichable
                          var firstindexword = -1;
                          var tcinst = 0;
                          
                          if (st.lines[0].words.length !== 0)
                          {
                            tcinst = st.lines[0].words[0].in;
                            firstindexword = st.lines[0].words[0].index;
                          }
                          else
                          {
                            if (st.lines[1].words.length !== 0)
                            {
                              tcinst = st.lines[1].words[0].in;
                              firstindexword = st.lines[1].words[0].index;
                            }
                          }


                          // on recherche l'index du premier mot sur le sous titre suivant
                          
                          var lastindexword = scriptptr.length -1;
                          if (indexst < lastst)
                          {
                              if (e.data.st[indexst+1].lines[0].words.length !== 0)
                                lastindexword = e.data.st[indexst+1].lines[0].words[0].index -1;
                              else
                              {
                                if (e.data.st[indexst+1].lines[1].words.length !== 0)
                                  lastindexword = e.data.st[indexst+1].lines[1].words[0].index -1 ;
                              }

                          }


                          if  (lastindexword > scriptptr.length -1) lastindexword = scriptptr.length -1;

                          if (firstindexword !== -1) 
                          {
                              const deca = st.in - tcinst ;
                              const stab = getStabiloForTranscriptApp(deca);
                              if (stab.stabilo > 0)
                              {
                                for (var w=firstindexword; w <= lastindexword; w++)
                                {                                  
                                    scriptptr[w].stabiloColor = stab.color;
                                    scriptptr[w].stabilo = stab.stabilo;
                                    scriptptr[w].ststarttime = st.in + .020;
                                }
                              }

                              else
                              {
                                for (var w=firstindexword; w <= lastindexword; w++)
                                {                                  
                                    scriptptr[w].ststarttime = st.in + .020;
                                }
                              }
                              

                          }


                        })
                        this.transcriptRef.current.onRefreshCanvas();

                      }

                      
                      var currentComputedSubtilesJSON = {};
                      currentComputedSubtilesJSON.subtitles = e.data.st;
                      currentComputedSubtilesJSON.asset = this.V2_GetAssetFromID(this.currentCalculedSubtitlesId);
                      currentComputedSubtilesJSON.params = this.state.stparams;
                      currentComputedSubtilesJSON.pjid = this.state.pjid;
                      currentComputedSubtilesJSON.appInfos = this.state.appInfos;
                      currentComputedSubtilesJSON.speakers = this.state.speakers;
                      

                      this.currentComputedSubtilesSerialized = JSON.stringify(currentComputedSubtilesJSON)
                      currentComputedSubtilesJSON ={};
                      // on envoie à la time line les nouveaux sous-titres
                      if ((this.timelineRef) && (this.timelineRef.current))
                      {
                        
                        this.timelineRef.current.setNewSubtitles(e.data.st, this.currentCalculedSubtitlesId);
                      }
                      // on informe aussi le player
                      if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
                        this.videoPlayerRef.current.setNewSubtitles(e.data.st);
                      // les infos
                      
                      this.V2_ComputeSubtitleInProgress= false;
                      if (this.forceSave) 
                      {
                        
                        this.forceSave = false;
                        this.TranscriptionisModified=true;
                        this.saveTranscription();
                      }
                      this.setState({appInfos: e.data.appInfos});

                      
                    }
              }
            }

        }
    }


    changeTranscription(time, index , json, id, changed)
    {



        const speakerIdsOrderByAppearance = uniqBy(json
          .filter(x => x.speakerId)
          .map((x) => x.speakerId), (x) => x);
        if (!isEqual(this.state.speakerIdsOrderByAppearance, speakerIdsOrderByAppearance)) {
          this.setState({
            speakerIdsOrderByAppearance,
          });
        }
        
        var lenx = 0;
        this.TranscriptionisModified = changed;
        if (index === -1 ) return;
        
        try {
          lenx = json.length;
        }
        catch
        {
          return;
        }

        const indextr = this.timelineRef.current.getIndexByType("newtrjson");
        // on ajoute la piste de transcription si elle n'existe pas
        if (indextr != -1)
        //this.timelineRef.current.addTrack ("newtrjson",json, "NEW","",0,this.currentCorrectedTranscriptId);
        //else
          this.timelineRef.current.setNewDatas (indextr, json, this.currentCorrectedTranscriptId);

        
        const indexst = this.timelineRef.current.getIndexByType("st");
        
        // on ajoute la piste de sous-titre si elle n'existe pas
        if (indexst === -1)
        this.timelineRef.current.addTrack ("st",[], "subtitles", "",0,this.currentCalculedSubtitlesId);

        // on lance le calcul des sous titres
        if (lenx ===0) return;

          

      this.TranscriptionisModifiedForSubtitle = changed;
      this.V2_GereSubtitleFiles(json); 
      this.moveTranscription(time)



    } 
    moveTranscription(time, force = false)
    {

      if ((force) || this.state.modeA)
        if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
            this.videoPlayerRef.current.goto(time);

    }  
    
    OtherFilesdownloadDone(blob, infos, file)
    {
      
      switch (infos)
      {
        case "motsc": // liste des mots collants
            this.motsc = getStickyWordsList(blob);
            
            break;

        case "commonerrors":
        {
            if ((this.transcriptRef)  && (this.transcriptRef.current))
                this.transcriptRef.current.setCommonErrors(blob);
            break;
        }
        case "mp4z":
            if ((this.timelineRef)  && (this.timelineRef.current))
            {
              this.timelineRef.current.addTrack ("mp4zaudio",blob, file,"",0,0);
              this.timelineRef.current.addTrack ("mp4zcp",blob, file,"",0,0);
              var script = this.transcriptRef.current.getTranscription();
              if (this.currentCalculedSubtitlesId > 0) this.TranscriptionisModifiedForSubtitle=true;
            }
            break;
      }

    }
  
  
  enqueueAction(action) {
    this.actionQueue.push(action);
    this.processNextAction();
  }

  async processNextAction() {
    if (this.isProcessingAction) {
      return; // empêche la ré-entrance
    }

    this.isProcessingAction = true;

    while (this.actionQueue.length > 0) {
      const action = this.actionQueue.shift();
      await action();
       // on met un wait car quand on tape très vite, les lettres s'inversent et le temps que ça mette à jour dans le state...
      await wait(10);
    }

    this.isProcessingAction = false;
  }
  
    handleKeyUp = (event) =>
    {
      
      if (this.cancelKeyboardEvent) return;
      
      const ret  = keyboard_special_up( event.code, event.key, event.shift, event.ctrl, event.alt);

      if (ret !=="" && this.transcriptRef && this.transcriptRef.current)
      {
        var code = ret.codePointAt(0);
        if (code >= 32) this.transcriptRef.current.addChar (event.key);
      }

    }
    

    handleKeyDown = (event) =>
    {
      if (this.cancelKeyboardEvent) return;


      if (this.state.displayCommonRaccourcis) {
        if (this.commonRaccourcisRef && this.commonRaccourcisRef.current) {
          this.commonRaccourcisRef.current.handleKeyDown(event);
          return;
        }
      }
      if ((this.containerBlockRef) && ((this.containerBlockRef).current))
        this.containerBlockRef.current.focus();

      if (keyboard_special_down(event.code, event.key, event.shiftKey, event.ctrlKey, event.altKey)) return;
      // on regarde si on a alt + numpad
      
      if (this.videoPlayerRef)
      {
        if (this.videoPlayerRef.current.keyboard_multi_gereKeyBoard(this.shortcuts_list, event.key, event.shiftKey, event.ctrlKey, event.altKey))
        {
          event.preventDefault();
          return;
        }
      }


      var block = this.state.blocks.find((b) => b.id === "transcription");
      if (!block) return;
      if (block.visible !== "visible") return;

      if (this.transcriptRef && this.transcriptRef.current) {
        this.transcriptRef.current.cptCurs = 0;
        var key = keyboard_multi_getKey("transcription",
          this.shortcuts_list,
          event.key,
          event.shiftKey,
          event.ctrlKey,
          event.altKey
        );

        if (key !== '' || event.key.length === 1) {
          this.enqueueAction(async () => {
            this.processShortcut(event, key);
          });
        }
       
  
        return;
      }
     



    }
  
  processShortcut = (event, key) => {

    

    if (key === "DISPLAYTABLECHAR") {
      this.setState({ displayCommonTableCaracteres: true });
      return;
    }
  
    if (key === "SETTCIN") this.onKeySetTimeCode("SETTCIN");
    if (key === "SETTCOUT") this.onKeySetTimeCode("SETTCOUT");

    
        
    if (key !== '') {
      event.preventDefault();
      this.transcriptRef.current.processShortcut(key);
      return;
    }
        
    var char = event.key;
    if (char.length === 1) {
      var code = char.codePointAt(0);
      if (code >= 32) this.transcriptRef.current.addChar(event.key);
    }
  };

    handleGotoTime(value)
    {
      if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
        this.videoPlayerRef.current.goto(value);

      if (this.transcriptRef && this.transcriptRef.current) {
        this.transcriptRef.current.goto(value);
      }

    }

  onChangeTimeLineZoom(value)
  {
    if (this.timelineRef && this.timelineRef.current) 
      this.timelineRef.current.setZoom(value);

  }


    handleTimeLineWheel(value)
    {      
      if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
        this.videoPlayerRef.current.addtime(value);
    }


  VideoReady(duration)
  {
    if ((this.timelineRef) && (this.timelineRef.current))
        this.timelineRef.current.setCurrentDuration(duration);
  
  }

  onNewTime(time, forceRedraw = false)
  {
    if ((this.sequencesRef) && (this.sequencesRef.current))
      this.sequencesRef.current.setTimeCode(this.videoPlayerRef.current.getTimeCode());
    this.setState({currentTimeCodePlayer:this.videoPlayerRef.current.getTimeCode()})
    if ((this.timelineRef) && (this.timelineRef.current))
    {
        try
        {
           this.timelineRef.current.setCurrentTimeFromPlayer(time, forceRedraw);
        }
        catch
        {
          return;
        }
    }
  }    

forceRecomputeFromTimeLine()
{
    
        var script = this.transcriptRef.current.getTranscription();
        if (script != null) 
          if (this.currentCalculedSubtitlesId > 0)
          {
            this.TranscriptionisModifiedForSubtitle = true;
            this.TranscriptionisModified = true;
          }

}

  onchangeparams(params)
  {
    // on a changé un paramètres dans la fenêtre de droite


    

    

    switch (params.type)
    {
      case "st":
        this.state.stparams = configurations_framestotime(params.value,params.value.num,params.value.den,params.value.dropframe);

        this.setState({stparams: this.state.stparams});
      if ((this.timelineRef) && (this.timelineRef.current))
          this.timelineRef.current.setParamsST(params.value);
      
        // on va recalculer les sous titres 
        
        var script = this.transcriptRef.current.getTranscription();
        if (script != null) 
          if (this.currentCalculedSubtitlesId > 0)
          {
            this.TranscriptionisModifiedForSubtitle = true;
            this.TranscriptionisModified = true;
          }
          // est-ce qu'il faut recalculer les tcmanual
          if ( ("recompute" in params) && (params.recompute))
          {

              if ((this.transcriptRef) && (this.transcriptRef.current))
              {

                var scriptptr = this.transcriptRef.current.getTranscriptionPtr();
                if (scriptptr)
                {
                  scriptRecomputeFromApp(scriptptr,this.state.stparams);
                  this.transcriptRef.current.onRefreshCanvas();
                  this.TranscriptionisModifiedForSubtitle = true;
                }
              }


          }
            
      break;

        case "applications":
          this.setState({applicationsparams: params.value});
          // on ecrit ça
          const datasapp = {
            id: getCurrentUserDatas().id,
            current: 0,
            mode: 2,
            submode: 0,
            values: JSON.stringify(params.value),

          }
          var userdatas = getCurrentUserDatas();
          userdatas.config.paramsapp = params.value;
          setCurrentUserDatas(userdatas);
          apiSaveUserConfig(datasapp, null);
          break;


      case "timeline":
          this.setState({timelineparams: params.value});
          // on ecrit ça

          const datas = {

            id: getCurrentUserDatas().id,
            current: 0,
            mode: 0,
            submode: 1,
            values: JSON.stringify(params.value),

          }

          



          var userdatas = getCurrentUserDatas();
          userdatas.config.transcription.timeline = params.value;
          setCurrentUserDatas(userdatas);

          apiSaveUserConfig(datas, null);



        break;
      case "player":

          const datasplayer = {

            id: getCurrentUserDatas().id,
            current: 0,
            mode: 0,
            submode: 2,
            values: JSON.stringify(this.state.playerparams),

          }

          var userdatas = getCurrentUserDatas();
          userdatas.config.transcription.player = this.state.playerparams;
          setCurrentUserDatas(userdatas);

          

          apiSaveUserConfig(datasplayer, null);

          

        this.videoPlayerRef.current.handleReady();
        break;
    }
    if ((this.timelineRef) && (this.timelineRef.current)) this.timelineRef.current.forceRecreate();

  }


  disableOptionInToolBar(key,disable)
  {
      var ttips = this.state.toolsbar;
      ttips.families.forEach((family, index) => 
      {
          family.items.forEach((item, index) => 
            {
                if ((item.type !== "space") && (item.key.key === key))  item.disable = disable;
          });
      });
      this.setState ({toolsbar: ttips});
  }

  updateToggleValueInToolBar(key,value)
  {
      var ttips = this.state.toolsbar;
      ttips.families.forEach((family, index) => 
      {
          
          family.items.forEach((item, index) => 
            {
                
                if ((item.type !== "space") && (item.key.key === key))  item.value = value;
          });
            
      });
      this.setState ({toolsbar: ttips});
  }

  exitAllPopup()
  {
      this.setState({
        deleteChildsAssetPopup: false,
        createANewTranscriptionPopup: false,
        deleteConsfigurationPopup: false,
        childsAssetList:[],
      })
      if ((this.assetsManagerRef) && (this.assetsManagerRef.current))
      this.assetsManagerRef.current.reloadAllAssets();
  }

  onReallyDeleteChildsAsset()
  {
      var datas = {asid: this.currentCorrectedTranscriptId, delete: true};
      
      apiGetAllChildsSubtitleAssets (datas, this.exitAllPopup);

  }
  onReadAllChildSubtitleAssets(datas)
  {
    
    // on ne gere que les fichiers de sous titres astype = 5
    var nbfiles = 0;
    datas.forEach(oneasset =>{
      if (oneasset.astype == 5)
        nbfiles++;
    })
    if (nbfiles !== 0)
    {

      var texte = {
        "fr":"Voulez vous supprimer ces fichiers de sous-titres corrigés :",
        "en": "Do you realy want to delete this subtitles files :"
      }
      if (datas.length == 1)
        texte = {
          "fr":"Voulez vous supprimer ce fichier de sous-titres corrigé :",
          "en": "Do you realy want to delete this subtitle file :"
        }

        var suite = "\r\n";
        datas.forEach(oneasset =>{
          if (oneasset.astype == 5)
          {
            suite = suite + "\r\n"+ oneasset.asid+" "+oneasset.astitle;
          }
        })
      

        texte.fr = texte.fr + suite;
        texte.en = texte.en + suite;

      

      this.setState({
        deleteChildsAssetPopup: true,
        childsAssetList:datas,
        popupText: texte,
      })
    }
  }

  handleClickOnWaveForm (timecode, atEnd)
  {

      
      if ((this.transcriptRef) && (this.transcriptRef.current))
      {
        const wordIndex = this.transcriptRef.current.isCursorAtEndOfWord().wordIndex;
        var scriptptr = this.transcriptRef.current.getTranscriptionPtr();
        if (scriptptr)
        {
          createNewTimeCodesForTranscription (scriptptr, wordIndex, atEnd, timecode, this.state.stparams);
          this.transcriptRef.current.onRefreshCanvas();
          this.TranscriptionisModifiedForSubtitle = true;
        }
      }

  }

  createOneUndo(key)
  {
    if ((this.transcriptRef) && (this.transcriptRef.current))
    {
      this.transcriptRef.current.addScriptToNewUndo(key)
      this.TranscriptionisModified = true;
    }

  }

  onKeySetTimeCode(key)
  {
    if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
    {
      const timecode = this.videoPlayerRef.current.getTimeCode();
      // on doit récuperer la position du curseur
      if ((this.transcriptRef) && (this.transcriptRef.current))
      {
        const wordIndex = this.transcriptRef.current.isCursorAtEndOfWord().wordIndex;
        const atEnd = (key === "SETTCOUT");
        var scriptptr = this.transcriptRef.current.getTranscriptionPtr();
        if (scriptptr)
        {
          createNewTimeCodesForTranscription (scriptptr, wordIndex, atEnd, timecode, this.state.stparams, this.createOneUndo);
          this.transcriptRef.current.onRefreshCanvas();
          this.TranscriptionisModifiedForSubtitle = true;
        }
      }
    }

  }

  onTcManual()
  {
    if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
    {
      const timecode = this.videoPlayerRef.current.getTimeCode();
      
      // on doit récuperer la position du curseur
      if ((this.transcriptRef) && (this.transcriptRef.current))
      {
        
        const wordIndex = this.transcriptRef.current.isCursorAtEndOfWord().wordIndex;
        const atEnd = this.transcriptRef.current.isCursorAtEndOfWord().isCursorAtEndOfWord;

        var scriptptr = this.transcriptRef.current.getTranscriptionPtr();
        if (scriptptr)
        {
          createNewTimeCodesForTranscription (scriptptr, wordIndex, atEnd, timecode, this.state.stparams);
          this.transcriptRef.current.onRefreshCanvas();
          this.TranscriptionisModifiedForSubtitle = true;
        }
      }
    }

    


  }


  onClickToolsBar(datas)
  {

    if (datas.key=="DELCHILDS")
    {

      var datas = {asid: this.currentCorrectedTranscriptId, delete: false};
      
      apiGetAllChildsSubtitleAssets (datas, this.onReadAllChildSubtitleAssets);
      return;          
    }

    if (datas.key==="SAVE")
    {
      this.saveTranscription();
      return;
    }
    
    switch (datas.cat) {
      case "mode":
        if (datas.key === "TCMANUAL") 
            this.onTcManual();

        if (datas.key === "STABILO")
        {
          this.displayDelay = !this.displayDelay;
          this.updateToggleValueInToolBar(datas.key, this.displayDelay);


          if (!this.displayDelay)
          {

              if (this.transcriptRef.current)
              {
                var scriptptr = this.transcriptRef.current.getTranscriptionPtr();
                scriptptr.forEach(o => {
                  o["stabilo"] = 0;
                });

                this.transcriptRef.current.onRefreshCanvas();
              }

          }
          else
            this.TranscriptionisModifiedForSubtitle = true;


        }

        if (datas.key === "LOCKVIDEO")
        {
          setCurrentModeTranscript ({modeA: !this.state.modeA});
          
          this.updateToggleValueInToolBar(datas.key, !this.state.modeA);
          this.setState({modeA: !this.state.modeA})
          return;
        }
        break;

      case "transcriptshortcut":
        if (this.transcriptRef && this.transcriptRef.current) {
          this.transcriptRef.current.processShortcut(datas.key);
          return;
        }
  
        break;
      case "display":
        var block = this.state.blocks.find((b) => b.id === datas.key);
        if (!block) return;
        block.visible = "visible";
        this.setState({ blocks: this.state.blocks });
        break;
    
      case "sequences":
        switch (datas.key)
        {
          case "sequencesplus":
            this.sequences_createsequences();
            return;
          case "addsequence":

            if ((this.timelineRef) && (this.timelineRef.current) && (this.sequencesRef) && (this.sequencesRef.current))
            {
              const seqtrack = this.timelineRef.current.getSequenceTrack();
              if ((seqtrack) && !this.sequencesRef.current.getOneSequenceModified())
              {
                const timecode = this.videoPlayerRef.current.getTimeCode();
                const sequence = seqtrack.getMouseDown(timecode)
                if (sequence.sequenceId !== -1) 
                {
                    const den= ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden);
                    const num= ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum);

                    if (seqtrack.canCreateSequence(sequence.sequenceId, V2_RoundedTimeCode(timecode,num,den)))
                    {
                        // ici c'est possible
                        this.doActionSequence ("INSERT", sequence.sequence, sequence.sequenceId, timecode, 0,0, 0);
                    }
                }
              }

            }

            break;
          case "deletesequencebefore":
            if ((this.timelineRef) && (this.timelineRef.current) && (this.sequencesRef) && (this.sequencesRef.current))
            {
              const seqtrack = this.timelineRef.current.getSequenceTrack();
              if ((seqtrack) && !this.sequencesRef.current.getOneSequenceModified())
              {
                const timecode = this.videoPlayerRef.current.getTimeCode();
                const sequence = seqtrack.getMouseDown(timecode)
                if (sequence.sequenceId !== -1) 
                {
                    if (seqtrack.canDeleteWithPrevious(sequence.sequenceId))
                    {
                        // ici c'est possible
                        this.doActionSequence ("DELETEWITHPREVIOUS", sequence.sequence, sequence.sequenceId, 0, 0,0, 0);
                    }
                }
              }

            }
            break;


          case "deletesequenceafter":
            if ((this.timelineRef) && (this.timelineRef.current) && (this.sequencesRef) && (this.sequencesRef.current))
            {
              const seqtrack = this.timelineRef.current.getSequenceTrack();
              if ((seqtrack) && !this.sequencesRef.current.getOneSequenceModified())
              {
                const timecode = this.videoPlayerRef.current.getTimeCode();
                const sequence = seqtrack.getMouseDown(timecode)
                if (sequence.sequenceId !== -1) 
                {
                    if (seqtrack.canDeleteWithNext(sequence.sequenceId))
                    {
                        // ici c'est possible
                        this.doActionSequence ("DELETEWITHNEXT", sequence.sequence, sequence.sequenceId, 0, 0,0, 0);
                    }
                }
              }

            }
            break;

          case "undosequence":


              if (this.undosequences.length === 0) return;
              var sequences = structuredClone(this.state.sequences);
              sequences.sequences = this.undosequences.pop();

              this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
              this.setState ({sequences: sequences})
              if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
            break;
        }
        break;

      case "shortcuts":

        switch (datas.key) {
          case 'commonShortcuts':            
            this.setState({ displayCommonRaccourcis: true });
            break;
          
          case 'commonCharacters':            
            this.setState({ displayCommonTableCaracteres: true });
            break;

        }
        
        break;
      
      case "layouts":
        switch (datas.key) 
        {
          case "loaddef1":
            var layout = getDefaultLayout("transcription", 1);
            layout = this.V2_SetCurrentAssetToBlock(layout);
            this.setCurrentLayout(0);
            this.setState({ blocks: layout });
            break;


          case "loaddef2":
            var layout = getDefaultLayout("transcription", 2);
            layout = this.V2_SetCurrentAssetToBlock(layout);
            this.setCurrentLayout(1);
            this.setState({ blocks: layout });
            break;

          case "save1":
            saveLayout("transcription", 1, this.state.blocks);
            this.saveUserLayout (2); 
            break;
          case "save2":
            saveLayout("transcription", 2, this.state.blocks);
            this.saveUserLayout (3); 
            break;
          case "save3":
            saveLayout("transcription", 3, this.state.blocks);
            this.saveUserLayout (4); 
            break;
            
          case "load1":
            var userdatas = getCurrentUserDatas();
            var layout = userdatas.config.transcription.blocks.user1;
            
            layout.forEach(block => {block.span = (<></>)});
            layout = this.V2_SetCurrentAssetToBlock(layout);
            this.setCurrentLayout(2);
            this.setState({ blocks: layout });
            break;


          case "load2":
            var userdatas = getCurrentUserDatas();
            var layout = userdatas.config.transcription.blocks.user2;
            
            layout.forEach(block => {block.span = (<></>)});
            layout = this.V2_SetCurrentAssetToBlock(layout);
            this.setCurrentLayout(3);
            this.setState({ blocks: layout });
            break;


          case "load3":
            var userdatas = getCurrentUserDatas();
            var layout = userdatas.config.transcription.blocks.user3;
            layout.forEach(block => {block.span = (<></>)});
            layout = this.V2_SetCurrentAssetToBlock(layout);
            this.setCurrentLayout(4);
            this.setState({ blocks: layout });
            break;

        }


        break;
    }
  }

  setCurrentLayout(current)
  {
    var userdatas = getCurrentUserDatas();
    var alllayout = [];
    alllayout.push ([]);
    alllayout.push ([]);
    alllayout.push (userdatas.config.transcription.blocks.user1);
    alllayout.push (userdatas.config.transcription.blocks.user2);
    alllayout.push (userdatas.config.transcription.blocks.user3);
    alllayout = JSON.parse(JSON.stringify(alllayout));

    alllayout.forEach( layout => {
      layout.forEach (block => {
        block.span = "SPAN_1";    
      })      
    })

    

    const datas = {

      id: getCurrentUserDatas().id,
      current: current,
      mode: 0,
      submode: 0,
      values: JSON.stringify(alllayout),

    }

    userdatas.config.transcription.current = current;
    setCurrentUserDatas(userdatas);

    apiSaveUserConfig(datas, null);
  }

  saveUserLayout(current)
  {
    // 0= transcription, 0 = blocks



    
    var userdatas = getCurrentUserDatas();
    var alllayout = [];
    alllayout.push ([]);
    alllayout.push ([]);
    alllayout.push (userdatas.config.transcription.blocks.user1);
    alllayout.push (userdatas.config.transcription.blocks.user2);
    alllayout.push (userdatas.config.transcription.blocks.user3);

    alllayout[current] = this.state.blocks;

    alllayout = JSON.parse(JSON.stringify(alllayout));

    alllayout.forEach( layout => {
      layout.forEach (block => {
        block.span = "SPAN_2";    
      })      
    })


    const datas = {

      id: getCurrentUserDatas().id,
      current: current,
      mode: 0,
      submode: 0,
      values: JSON.stringify(alllayout),

    }


    var blocks = JSON.parse(JSON.stringify(this.state.blocks));
    blocks.forEach(block =>{block.span = "SPAN_3"});

    switch (current)
    {
      case 2: userdatas.config.transcription.blocks.user1 = this.state.blocks; break;
      case 3: userdatas.config.transcription.blocks.user2 = this.state.blocks; break;
      case 4: userdatas.config.transcription.blocks.user3 = this.state.blocks; break;

    
    }
    userdatas.config.transcription.current = current;

    setCurrentUserDatas(userdatas);

    apiSaveUserConfig(datas, null);

  }

  onClickCommonRaccourcis(event) {
    switch (event.name) {
      case 'back':
        this.setState({ displayCommonRaccourcis: false });
        break;
        
      case 'save':
        keyboard_multi_savePersonnalKey(event.items);
        this.setState({ displayCommonRaccourcis: false });

        // On recharge la liste
        this.shortcuts_list = keyboard_multi_getShorCutList_by_apps_and_keyboard(["player", "transcription"]);
        break;
        
      default:
        return;
    }
  
  }

  onClickCommonTableCaracteres(event) {
    switch (event.name) {
      case 'back':
        this.setState({ displayCommonTableCaracteres: false });
        break;
      
      case 'char':

      
        if (this.transcriptRef && this.transcriptRef.current) {


          const hasArabicOrHebrew = event.subset === "arabic" || event.subset === "hebrew";
          if (hasArabicOrHebrew) {
            this.transcriptRef.current.addHebrewOrArabicChar(event.value);
          }
          else {            
            this.transcriptRef.current.addChar(event.value);
          }
          

        }
       
        break;
      
      default:
        return;
    }
  }
    

  onCancelKeyboardEvent(value)
  {
    
    this.cancelKeyboardEvent =  value;
  }

  onChangeSpeakers(speakers) {
    const updatedSpeakers = orderBy(speakers, ['firstName', 'name']);

    this.setState({ speakers: updatedSpeakers });

    this.TranscriptionisModified = true;

    setTimeout(() => this.saveTranscription(), 100);
  }

  onMergeSpeaker(speakerId, mergeSpeakerId) {
   if (this.transcriptRef && this.transcriptRef.current) {
      const script = this.transcriptRef.current.getTranscriptionPtr();

      script
        .filter((x) => x.speakerId === speakerId)
        .forEach((item) => (item.speakerId = mergeSpeakerId));

      this.transcriptRef.current.onRefreshCanvas();
    }

    const speakers = this.state.speakers.filter((x) => x.id !== speakerId);

    this.onChangeSpeakers(speakers);
  }

  onIdentifySpeakerDialoguesClick(speaker){
    if (this.transcriptRef && this.transcriptRef.current) {
      this.transcriptRef.current.onIdentifySpeakerDialogues(speaker);
    }
  }

  render()
  {
    // https://neweasysubdatas.easydirect.fr/videos/BR0217LN_EasySub.mp4

    var addwindows = []
    if (this.state.displayCommonRaccourcis) {
      addwindows.push(<CommonRaccourcis ref={this.commonRaccourcisRef} display={this.state.displayCommonRaccourcis} onButton={this.onClickCommonRaccourcis} default="transcription" />)
    }

    if (this.state.displayCommonTableCaracteres) {
      addwindows.push(<CommonTableCaracteres ref={this.commonTableCaracteresRef} display={this.state.displayCommonTableCaracteres} onButton={this.onClickCommonTableCaracteres} />)
    }
   
      if (this.state.deleteConsfigurationPopup)
      {
        addwindows.push(
        <SimplePopup display={this.state.deleteConsfigurationPopup} 
              title="" text={this.state.popupText} 
              onCancel={this.exitAllPopup}

              buttons ={
                [
                  {text:{"fr":"Oui","en":"Yes"},onclick:this.onDeleteConfiguration},
                  {text:{"fr":"Non","en":"No"},onclick:this.exitAllPopup},
                ]
              } 
          />
            )
      }

    

    if (this.state.displayApplyOffset)
    {
      addwindows.push(
        <ApplyOffsetVideo
            display = {this.state.displayApplyOffset} 
            onButton={this.handleEndApplyVideo}
            assets = {this.assetsList}
            datas = {this.state.ApplyOffsetDatas}
            pjid={this.state.pjid}
        />
      )
    }


    return (
      <>
      <SimplePopup display={this.state.deleteChildsAssetPopup} 
            title="" text={this.state.popupText} 
            onCancel={this.exitAllPopup}

            buttons ={
              [
                {text:{"fr":"Oui","en":"Yes"},onclick:this.onReallyDeleteChildsAsset},
                {text:{"fr":"Non","en":"No"},onclick:this.exitAllPopup},
              ]
            } 
        />

      <SimplePopup display={this.state.createANewTranscriptionPopup} 
            title="" text={this.state.popupText} 
            onCancel={this.returnToMainPage}

            buttons ={
              [
                {text:{"fr":"Oui","en":"Yes"},onclick:this.onCreateANewTranscription},
                {text:{"fr":"Non","en":"No"},onclick:this.returnToMainPage},
              ]
            } 
        />




      <div className={styles.appDiv}  tabIndex={0} id="AppTranscriptContainer">
        <div className={styles.appDivTop}>
          <div className={styles.appDivLogoFtva}>
              <img src={ftva} style = {{width:"100%", verticalAlign:"middle"}}/>
          </div>
 <        div className={styles.appDivProject}>
              <div className={styles.appDivProjectLeft}>
              <h1>TRANSCRIPTION</h1>
              </div>
              <div className={styles.appDivProjectRight}>
              <AppHeader onCancelKeyboardEvent={this.onCancelKeyboardEvent} ref={this.appHeaderRef} canclose={false} canedit={true}/>
              </div>

          </div>
        <div className={styles.appDivLogo}>
          <Icon image={easytt} height="100%" width="100%"/>
          </div>
          <div className={styles.appDivUser}>
          <User onnavigate = {this.props.onnavigate} onCancelKeyboardEvent={this.onCancelKeyboardEvent}/>
          </div>
        </div>
        <div className={styles.appDivToolsBar}>
          <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar} />
          
        </div>
        <div className={styles.appDivBody} ref = {this.bodyDivRef}>
          
          <div className={styles.appPanelsContainer} 
            div tabIndex={1} 
            style = {{outline:"none"}}
            ref = {this.divTranscriptRef} 
            >

            <AppMediaAssets     
                                pjid={this.state.pjid} 
                                mode = "transcription"
                                onCancelKeyboardEvent = {this.onCancelKeyboardEvent}
                                onClick = {this.onClickOnAsset}
                                onChange = {this.onAssetsManagerChange}
                                mediaassetref={this.assetsManagerRef}
                                ref={this.appMediaAssetsRef}
                                codatas = {this.state.codatas}
                                stparams = {this.state.stparams}
                                onaction = {this.onAppMediaAssetsAction}
                                tree={true}
                                refreshKey = {this.state.refreshKey}
                                appInfos = {this.state.appInfos}>                        
                                
                                
            
            
            
            <AppSettings refreshKey={this.state.refreshKey} 
              timelineparams = {this.state.timelineparams} 
              codatas = {this.state.codatas} 
              playerparams={this.state.playerparams} 
              applicationsparams = {this.state.applicationsparams}

              defaultsparams={this.state.defaultsparams} 
              stparams={this.state.stparams} 
              onchange={this.onchangeparams} 
              ref={this.appsettingsRef}
            >
            


        <div
          ref={this.containerBlockRef}
          tabIndex={0}
          style={{
            outline: "none",
            width: "100%",
            height: "100%",
            position: "relative",
            overflow: "hidden",
            marginTop: 0,
            backgroundColor:'transparent',
            userSelect: this.state.action ? "none" : "auto",

          }}
          >






          {this.state.blocks.map((block) => (
            <div 
              key={block.id}
              style={{
                position: "absolute",
                left: block.x,
                marginTop: 0,
                top: block.y,
                width: block.width,
                height: block.height,
                boxSizing: "border-box",
                backgroundColor: "black",
                borderRadius: 4,
                border: "2px solid rgba(80,80,80,1)",
                color:"white",
                userSelect: "none",
                zIndex: this.state.activeid===block.id?1:0,
                visibility: block.visible,
                padding: "2px",
                

              }}
              
              onMouseDown={(e) => {this.Blocks_onBlockMouseDown(block.id, e)}}
              onMouseMove={(e) => {this.Blocks_onBlockMouseMove(block.id, e)}}
              onMouseLeave={(e) => {this.Blocks_onBlockMouseLeave(block.id, e)}}  

            >
                <div style={{lineHeight:block.id === "timeline"?"1":"1.5",marginTop:"0px",paddingTop:"0px",  width:block.id === "timeline"?"calc(100% - 90px)":"calc(100% - 10px)",overflow:"hidden",whiteSpace: "nowrap"}}>
                    {block.span}
                    </div>
                  <div style={{ paddingTop: "0px", width: "100%", height: "100%" }}>
                    {
                      block.id === "timeline"?<div style={{
                        position: "absolute",
                        top: 1,
                        right: 20,
                        fontSize: 7,
                        cursor: "pointer",
                        userSelect: "none",
                        width: "70px",
                        height: "18px",
                      }}
                        onMouseDown={(e) => {e.stopPropagation()}}
                        onMouseMove={(e) => {e.stopPropagation()}}
                        onMouseLeave={(e) => {e.stopPropagation()}}
                      
                      >
                        <Zoom onChangeZoom = {this.onChangeTimeLineZoom} zoomValue = {this.state.zoomValue}/>
                      </div>:<></>
                    }
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        this.blocks_removeBlock(block.id);
                      }}
                      style={{
                        position: "absolute",
                        top: 1,
                        right: 1,
                        fontSize: 7,
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                    >
                      ✕
                    </button>

                        <div 
                          className={styles.appBlockContainer} 
                          style = {{height:block.id === "timeline"?"calc(100% - 16px)":"calc(100% - 24px)"}}
                          onMouseDown={(e) => {e.stopPropagation()}}
                        >

                
                    {
                        block.id === "transcription"? 
                        <Transcript ref = {this.transcriptRef}
                        
                        initialFontSize = {this.state.applicationsparams.transcription.initialFontSize}
                        onSwapTranscription = {this.onSwapTranscription}

                        onSave = {this.saveTranscription}
                        onChange = {this.changeTranscription}
                        onMove = {this.moveTranscription}     
                        
                        readonly={this.state.transcriptReadOnly}
                        languageToolUrl={this.languageToolUrl}
                        timecodeAsset = {this.state.timecodeAsset}
                        playerparams={this.state.playerparams}

                        speakers = {this.state.speakers}
                        

                        updateCP = {this.searchAllCpForTranscription}
                        
                        />


                        
                          :
                            block.id === "player"?
                                <VideoPlayerTr ref={this.videoPlayerRef} 
                                src = {this.state.videopath}
                                video = {this.state.videoforplayer}
                                onNewTime={this.onNewTime}
                                onready={this.VideoReady}
                                params= {this.state.playerparams}
                                onAddCP = {this.addcp}
                                
                                onMustReload = {this.handleOnMustReload}
                                stparams = {this.state.stparams}

                                />


                            :
                                  block.id === "timeline"?
                                    <TimeLine ref = {this.timelineRef}  
                                    playaddtime={this.handleTimeLineWheel}
                                    type="transcription"
                                    video = {this.state.videoforplayer}
                                    timecodeAsset = {this.state.timecodeAsset}
                                    forceRecompute = {this.forceRecomputeFromTimeLine}
                                    onCpListLoaded = {this.handleCPFileLoaded}
                                    onClickOnWaveForm = {this.handleClickOnWaveForm}
                                    playerparams = {this.state.playerparams}
                                    timelineparams = {this.state.timelineparams}

                                    onClickOnSequence = {this.onClickOnSequence}
                                    doActionSequence = {this.doActionSequence}
                                    onChangeZoomValue = {e=>{
                                      
                                      this.setState({zoomValue:e})
                                    }}

                                    gototime={this.handleGotoTime}/>
                                  :
                                    block.id === "speakers"?
                                    <SpeakersList
                                        speakers = {this.state.speakers}
                                        speakerIdsOrderByAppearance={this.state.speakerIdsOrderByAppearance}
                                        type="transcription"
                                        onChangeSpeakers={this.onChangeSpeakers}
                                        onMergeSpeaker={this.onMergeSpeaker}
                                        canMerge={this.state.speakers.length > 1}
                                        canIdentifySpeakers={true}
                                        onIdentifySpeakerDialoguesClick={this.onIdentifySpeakerDialoguesClick}
                                    />
                                    :
                                    <SequencesBlock
                                        type="transcription"
                                        sequences = {this.state.sequences}
                                        assetSequences = {this.state.sequencesasset}
                                        onChange = {this.sequences_onChangeSequences}
                                        onGetText = {this.sequences_onGetText}
                                        onMove = {this.sequences_goto}
                                        addUndo = {this.sequences_add_one_undo}
                                        timecodeasset = {this.state.timecodeAsset}
                                        timecode = {this.state.currentTimeCodePlayer}


                                        onGetTimeCode ={
                                          e=>{
                                            if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
                                            {
                                              return this.videoPlayerRef.current.getTimeCode()
                                            }
                                            return 0;
                                          }
                                        }
                                        ref = {this.sequencesRef}

                                    />
                                  

                    }


                </div>
              </div>
            </div>
          ))}

  




          </div>

              </AppSettings>
              </AppMediaAssets>
            </div>
          
          
        </div>
        
        {addwindows}
      </div>
      </>
    )
    }


    //  ************************************************************************************************************
    //  * nouvelle gestion de la souris sur les blocks
    //  ************************************************************************************************************
  convertiPourcentToPixel(pourcentValue, maxValueInPixel)
  {
    // pourcentValue = String type "0%"
    const num = parseFloat(pourcentValue);
    return Math.round((num * maxValueInPixel) / 100);
  }
  convertiPixelToPourcent(pixelValue, maxValueInPixel)
  {
   
    const v= (pixelValue/maxValueInPixel)*100;
    return v.toFixed(2) + "%"
  }

    blocks_removeBlock = (id) => {

    var block = this.state.blocks.find((b) => b.id === id);
    if (!block) return;
    block.visible="hidden";
    this.setState({blocks: this.state.blocks});
    return;

  };

    Blocks_onBlockMouseLeave(id, e)
    {
        if (this.state.action.current!=="none") return;
        const container = this.containerBlockRef.current;
        if (!container) return;
        
        container.style.cursor = "default";
    }

    Blocks_onBlockMouseDown(id, e)
    {
        

        
        if (this.state.action.current!=="none") return;

        var { clientX, clientY } = e;
        const block = this.state.blocks.find((b) => b.id === id);
        if (!block) return;

        const container = this.containerBlockRef.current;
        if (!container) return;
        const rect = container.getBoundingClientRect();

        const startX = this.convertiPourcentToPixel(block.x, rect.width);
        const startY = this.convertiPourcentToPixel(block.y, rect.height);
        const width = this.convertiPourcentToPixel(block.width, rect.width);
        const height = this.convertiPourcentToPixel(block.height, rect.height);

        // on cherche si on a un cas qui va
        

        const blockclientX = clientX - startX - rect.left;
        const blockclientY = clientY - startY - rect.top;

        var action = this.Blocks_GetAction(blockclientX,blockclientY,width,height);

        

        
        if (action.next !=="")
        {
            
            e.stopPropagation();
            e.preventDefault();
            action.current = action.next;
            action.startmouseX = clientX;
            action.startmouseY = clientY;
            action.block={};
            action.block.startX = startX;
            action.block.startY = startY;
            action.block.width = width;
            action.block.height = height;
            action.enCollision = false;


            const pixBlock = this.blocks_BlockToPixel(block, rect.width, rect.height);
            // on regarde si le bloc est en collision avec un for
            for (var ind=0; ind < this.state.blocks.length; ind++)
            {
              if (this.state.blocks[ind].id !== block.id)
              {
                  const pixBlockInd = this.blocks_BlockToPixel(this.state.blocks[ind], rect.width, rect.height);
                  if (this.blocks_checkCollision(pixBlock, pixBlockInd))
                  {
                      action.enCollision = true;
                      
                  }
              }
            }

            this.setState({
              action: action,
              activeid: block.id,
              blockid: id,
            }, () => {
              window.addEventListener("mousemove", this.blocks_onMouseMove, {capture:true});
              window.addEventListener("mouseup", this.blocks_onMouseUp);
            });

            
        }


    }

    blocks_onMouseMove(e)
    {
     
        
        if (this.state.action.current==="none") return;

        const id = this.state.blockid;
        var { clientX, clientY } = e;

        
        const block = this.state.blocks.find((b) => b.id === id);
        if (!block) 
          return;
        
        const container = this.containerBlockRef.current;
        if (!container) 
        {
          
          return;
        }
        const rect = container.getBoundingClientRect();

        const startX = this.convertiPourcentToPixel(block.x, rect.width);
        const startY = this.convertiPourcentToPixel(block.y, rect.height);
        const width = this.convertiPourcentToPixel(block.width, rect.width);
        const height = this.convertiPourcentToPixel(block.height, rect.height);
        const minWidth = this.convertiPourcentToPixel(block.minWidth, rect.width);
        const minHeight = this.convertiPourcentToPixel(block.minHeight, rect.height);


        const deltaX = clientX - this.state.action.startmouseX;
        const deltaY = clientY - this.state.action.startmouseY;

        


        if (this.state.action.current === "move")
        {

            
            var newX = this.state.action.block.startX + deltaX;
            var newY = this.state.action.block.startY + deltaY;


            if (newX + width > rect.width) newX = rect.width - width;
            if (newY + height > rect.height) newY = rect.height - height;
            if (newX < 0) newX = 0;
            if (newY < 0) newY = 0;


            const pnewX = this.convertiPixelToPourcent(newX, rect.width);
            const pnewY = this.convertiPixelToPourcent(newY, rect.height);

          var newblocks = this.state.blocks.map (b => {
            return b.id === id ? { ...b, x: pnewX, y: pnewY } : b
          });

          var action = this.state.action;
          e.stopPropagation();
          e.preventDefault();

          this.setState({blocks: newblocks, action: action});
          return;

        }

        var change=false;
        var newblocks = this.state.blocks;
        var action = this.state.action;
        const intermin = 7;

        var memoblock = JSON.parse(JSON.stringify(newblocks));
        

        if (this.state.action.right) // on grossi à droite
        {
        
            
            var newWidth = this.state.action.block.width + deltaX;

            

            if (startX + newWidth > rect.width) newWidth = rect.width - startX;
            if (newWidth < minWidth) newWidth = minWidth; // a voir les largeurs mini par type
            const pnewWidth = this.convertiPixelToPourcent(newWidth, rect.width);
            newblocks = newblocks.map (b => {
              return b.id === id ? { ...b, width: pnewWidth} : b
            });

            // Collision ?
            if (!this.state.action.enCollision) newblocks = this.blocks_CheckCollision_right (id, newblocks, memoblock, rect, intermin);

            change=true;
        }


        if (this.state.action.left) // on grossi à gauche
        {
            var newStartX = this.state.action.block.startX + deltaX;
            var newWidth = this.state.action.block.width - deltaX;
            if ((newWidth >= minWidth) && (newStartX >= 0))
            {
              const pnewWidth = this.convertiPixelToPourcent(newWidth, rect.width);
              const pnewStartX = this.convertiPixelToPourcent(newStartX, rect.width);
              newblocks = newblocks.map (b => {
                return b.id === id ? { ...b, width: pnewWidth, x: pnewStartX} : b
              });
              if (!this.state.action.enCollision) newblocks = this.blocks_CheckCollision_left (id, newblocks, memoblock, rect, intermin);
              change=true;
            }
        }
        
        if (this.state.action.top) // on grossi en haut
        {
            var newStartY = this.state.action.block.startY + deltaY;
            var newHeight = this.state.action.block.height - deltaY;
            if ((newHeight >= minHeight) && (newStartY >= 0))
            {
              const pnewHeight = this.convertiPixelToPourcent(newHeight, rect.height);
              const pnewStartY = this.convertiPixelToPourcent(newStartY, rect.height);
              newblocks = newblocks.map (b => {
                return b.id === id ? { ...b, height: pnewHeight, y: pnewStartY} : b
              });

              if (!this.state.action.enCollision) newblocks = this.blocks_CheckCollision_top (id, newblocks, memoblock, rect, intermin);
              change=true;
            }
        }


        if (this.state.action.bottom) // on grossi en bas
        {
            var newHeight = this.state.action.block.height + deltaY;
            if (startY + newHeight > rect.height) newHeight = rect.height - startY;
            if (newHeight < minHeight) newHeight = minHeight; // a voir les largeurs mini par type
            const pnewHeight = this.convertiPixelToPourcent(newHeight, rect.height);

            newblocks = newblocks.map (b => {
              return b.id === id ? { ...b, height: pnewHeight} : b
            });

            if (!this.state.action.enCollision) newblocks = this.blocks_CheckCollision_bottom (id, newblocks, memoblock, rect, intermin);
            change=true;
        }




        if (change)
        {
          this.setState({blocks: newblocks, action: action});
        }
        else
        {
          this.setState({action: action});

        }

    }

    // *********************************************************************************************************************
    // * check des collisions
    // *********************************************************************************************************************

lineIntersectsRect(x1, y1, x2, y2, rx, ry, rw, rh) {
  // 1. Si un des points est dans le rectangle
  if (
    this.pointInRect(x1, y1, rx, ry, rw, rh) ||
    this.pointInRect(x2, y2, rx, ry, rw, rh)
  ) {
    return true;
  }

  // 2. Sinon, teste les intersections avec les côtés du rectangle
  return (
    this.linesIntersect(x1, y1, x2, y2, rx, ry, rx + rw, ry) || // top
    this.linesIntersect(x1, y1, x2, y2, rx, ry + rh, rx + rw, ry + rh) || // bottom
    this.linesIntersect(x1, y1, x2, y2, rx, ry, rx, ry + rh) || // left
    this.linesIntersect(x1, y1, x2, y2, rx + rw, ry, rx + rw, ry + rh) // right
  );
}

pointInRect(px, py, rx, ry, rw, rh) {
  return px >= rx && px <= rx + rw && py >= ry && py <= ry + rh;
}

// Fonction qui teste l'intersection de deux segments
linesIntersect(x1, y1, x2, y2, x3, y3, x4, y4) 
{
  function ccw(ax, ay, bx, by, cx, cy) {
    return (cy - ay) * (bx - ax) > (by - ay) * (cx - ax);
  }

  return (
    ccw(x1, y1, x3, y3, x4, y4) !== ccw(x2, y2, x3, y3, x4, y4) &&
    ccw(x1, y1, x2, y2, x3, y3) !== ccw(x1, y1, x2, y2, x4, y4)
  );
}


    blocks_checkCollision(blockA, blockB) 
    {
    return !(
        blockA.x + blockA.width <= blockB.x ||
        blockA.x >= blockB.x + blockB.width ||
        blockA.y + blockA.height <= blockB.y ||
        blockA.y >= blockB.y + blockB.height
      );
  }

  blocks_BlockToPixel(bloc, width, height)
  {
  
    var retbloc = {};
    retbloc.x = this.convertiPourcentToPixel(bloc.x, width);
    retbloc.y = this.convertiPourcentToPixel(bloc.y, height);
    retbloc.width = this.convertiPourcentToPixel(bloc.width, width);
    retbloc.height = this.convertiPourcentToPixel(bloc.height, height);
    retbloc.minWidth = this.convertiPourcentToPixel(bloc.minWidth, width);
    retbloc.minHeight = this.convertiPourcentToPixel(bloc.minHeight, height);
    return retbloc;
  
  }

    blocks_CheckCollision_right (id, newblocks, memoblock, rect, intermin)
    {

        const index = newblocks.findIndex(item => item.id === id);
        if (index === -1) return newblocks;
        for (var ind = 0; ind < newblocks.length; ind++)
        {
            if ((index !== ind) && (newblocks[ind].visible !=="hidden")) // on ne fait rien sur celui la
            {
                // on regarde si le bloc était déja en collision, dans ce cas on fait rien
                const block = newblocks[index];
                const pixBlock = this.blocks_BlockToPixel(block, rect.width, rect.height);
                const blockIndLast = memoblock[ind];
                const pixBlockIndLast = this.blocks_BlockToPixel(blockIndLast, rect.width, rect.height);
                //if ((!this.blocks_checkCollision(pixBlock, pixBlockIndLast)) || ignoreCollision)
                if (true)
                {
                    // avant il ne l'était pas mais maintenant que vais je faire ?
                    const blockInd = newblocks[ind];
                    const pixBlockInd = this.blocks_BlockToPixel(blockInd, rect.width, rect.height);
                    // test si la ligne verticale gauche entre dans le block en cours
                    if (this.lineIntersectsRect (pixBlockInd.x, pixBlockInd.y,pixBlockInd.x,pixBlockInd.y+pixBlockInd.height,
                        pixBlock.x, pixBlock.y, pixBlock.width+intermin, pixBlock.height))
                        {
                          // oui il faut revoir sa copie
                          

                          // ici on peut
                          var newx =  pixBlock.x + pixBlock.width + intermin;
                          var newwidth = pixBlockInd.width - (newx - pixBlockInd.x);
                          if (newwidth < pixBlockInd.minWidth) // on peut pas
                          {
                              // on retabli l'ancienne largeur du bloc
                              newblocks[index].width = memoblock[index].width;
                          }
                          else
                          {
                            newblocks[ind].x = this.convertiPixelToPourcent( newx, rect.width);
                            newblocks[ind].width = this.convertiPixelToPourcent( newwidth, rect.width);
                          }
                        }
                }
            }
        }
        return newblocks;

    }

    blocks_CheckCollision_bottom (id, newblocks, memoblock, rect, intermin)
    {

        const index = newblocks.findIndex(item => item.id === id);
        if (index === -1) return newblocks;
        for (var ind = 0; ind < newblocks.length; ind++)
        {
            if ((index !== ind) && (newblocks[ind].visible !=="hidden")) // on ne fait rien sur celui la
            {
                // on regarde si le bloc était déja en collision, dans ce cas on fait rien
                const block = newblocks[index];
                const pixBlock = this.blocks_BlockToPixel(block, rect.width, rect.height);
                const blockIndLast = memoblock[ind];
                const pixBlockIndLast = this.blocks_BlockToPixel(blockIndLast, rect.width, rect.height);
                //if ((!this.blocks_checkCollision(pixBlock, pixBlockIndLast)) || ignoreCollision)
                if (true)
                {
                    // avant il ne l'était pas mais maintenant que vais je faire ?
                    const blockInd = newblocks[ind];
                    const pixBlockInd = this.blocks_BlockToPixel(blockInd, rect.width, rect.height);
                    // test si la ligne horizontale en haut entre dans le block en cours
                    
                    if (this.lineIntersectsRect (pixBlockInd.x, pixBlockInd.y,pixBlockInd.x+pixBlockInd.width,pixBlockInd.y,
                        pixBlock.x, pixBlock.y, pixBlock.width, pixBlock.height+intermin))
                        {
                          // oui il faut revoir sa copie
                          

                          // ici on peut
                          var newy =  pixBlock.y + pixBlock.height + intermin;
                          var newheight = pixBlockInd.height - (newy - pixBlockInd.y);
                          if (newheight < pixBlockInd.minHeight) // on peut pas
                          {
                              // on retabli l'ancienne largeur du bloc
                              newblocks[index].height = memoblock[index].height;
                          }
                          else
                          {
                            newblocks[ind].y = this.convertiPixelToPourcent( newy, rect.height);
                            newblocks[ind].height = this.convertiPixelToPourcent( newheight, rect.height);
                          }
                        }
                }
            }
        }
        return newblocks;

    }

    blocks_CheckCollision_top (id, newblocks, memoblock, rect, intermin)
    {

        const index = newblocks.findIndex(item => item.id === id);
        if (index === -1) return newblocks;
        for (var ind = 0; ind < newblocks.length; ind++)
        {
            if ((index !== ind) && (newblocks[ind].visible !=="hidden")) // on ne fait rien sur celui la
            {
                // on regarde si le bloc était déja en collision, dans ce cas on fait rien
                const block = newblocks[index];
                const pixBlock = this.blocks_BlockToPixel(block, rect.width, rect.height);
                const blockIndLast = memoblock[ind];
                const pixBlockIndLast = this.blocks_BlockToPixel(blockIndLast, rect.width, rect.height);
                //if ((!this.blocks_checkCollision(pixBlock, pixBlockIndLast)) || ignoreCollision)
                if (true)
                {
                    // avant il ne l'était pas mais maintenant que vais je faire ?
                    const blockInd = newblocks[ind];
                    const pixBlockInd = this.blocks_BlockToPixel(blockInd, rect.width, rect.height);
                    // test si la ligne horizontale en haut entre dans le block en cours
                    
                    if (this.lineIntersectsRect (pixBlockInd.x, pixBlockInd.y + pixBlockInd.height,pixBlockInd.x+pixBlockInd.width,pixBlockInd.y+pixBlockInd.height,
                        pixBlock.x, pixBlock.y-intermin, pixBlock.width, pixBlock.height))
                        {
                          // oui il faut revoir sa copie
                          

                          // ici on peut
                          var newheight = pixBlock.y - pixBlockInd.y - intermin;
                          if (newheight < pixBlockInd.minHeight) // on peut pas
                          {
                              // on retabli l'ancienne largeur du bloc
                              newblocks[index].height = memoblock[index].height;
                          }
                          else
                          {
                            newblocks[ind].height = this.convertiPixelToPourcent( newheight, rect.height);
                          }
                        }
                }
            }
        }
        return newblocks;

    }


    blocks_CheckCollision_left (id, newblocks, memoblock, rect, intermin)
    {

        const index = newblocks.findIndex(item => item.id === id);
        if (index === -1) return newblocks;
        for (var ind = 0; ind < newblocks.length; ind++)
        {
            if ((index !== ind) && (newblocks[ind].visible !=="hidden")) // on ne fait rien sur celui la
            {
                // on regarde si le bloc était déja en collision, dans ce cas on fait rien
                const block = newblocks[index];
                const pixBlock = this.blocks_BlockToPixel(block, rect.width, rect.height);
                const blockIndLast = memoblock[ind];
                const pixBlockIndLast = this.blocks_BlockToPixel(blockIndLast, rect.width, rect.height);
                //if ((!this.blocks_checkCollision(pixBlock, pixBlockIndLast)) || ignoreCollision)
                if (true)
                {
                    // avant il ne l'était pas mais maintenant que vais je faire ?
                    const blockInd = newblocks[ind];
                    const pixBlockInd = this.blocks_BlockToPixel(blockInd, rect.width, rect.height);
                    // test si la ligne horizontale en haut entre dans le block en cours
                    
                    if (this.lineIntersectsRect (pixBlockInd.x+pixBlockInd.width, pixBlockInd.y ,pixBlockInd.x+pixBlockInd.width,pixBlockInd.y+pixBlockInd.height,
                        pixBlock.x-+intermin, pixBlock.y, pixBlock.width, pixBlock.height))
                        {
                          // oui il faut revoir sa copie
                          

                          // ici on peut
                          var newwidth = pixBlock.x - pixBlockInd.x - intermin;
                          if (newwidth < pixBlockInd.minWidth) // on peut pas
                          {
                              // on retabli l'ancienne largeur du bloc
                              newblocks[index].width = memoblock[index].width;
                          }
                          else
                          {
                            newblocks[ind].width = this.convertiPixelToPourcent( newwidth, rect.width);
                          }
                        }
                }
            }
        }
        return newblocks;

    }



    blocks_onMouseUp(e)
    {
        
        window.removeEventListener("mousemove", this.blocks_onMouseMove, {capture:true});
        window.removeEventListener("mouseup", this.blocks_onMouseUp);
        const action = {current:"none", next:""}
        
        this.setState({action:action});
        const container = this.containerBlockRef.current;
        if (!container) return;
        container.style.cursor = "default";
    }

    Blocks_GetAction(clientX,clientY, width, height)
    {
        var action = {
          next: "",
          current: "none",
        }
        
        const ecart=5;
        if ((clientX >=0) && (clientX <=ecart) && (clientY >=0) && (clientY <=ecart) ) // en haut à gauche
        {
            action.next =  "nw-resize";
            action.top = true;
            action.left = true;
            action.right = false;
            action.bottom = false;
            return action;
        }

        if ((clientX >=(width-ecart)) && (clientX <=width) && (clientY >=0) && (clientY <=ecart) ) // en haut à droite
        {
            action.next =  "ne-resize";
            action.top = true;
            action.left = false;
            action.right = true;
            action.bottom = false;
            return action;
        }

        if ((clientX >=0) && (clientX <=ecart) && (clientY >=(height-ecart)) && (clientY <=height) ) // en bas à gauche
        {
            action.next =  "sw-resize";
            action.top = false;
            action.left = true;
            action.right = false;
            action.bottom = true;

            return action;
        }

        if ((clientX >=(width-ecart)) && (clientX <=width) && (clientY >=(height-ecart)) && (clientY <=height) ) // en bas à droite
        {
            action.top = false;
            action.left = false;
            action.right = true;
            action.bottom = true;
            action.next =  "se-resize";
            return action;
        }

        if ((clientX >=0) && (clientX <=ecart)  ) // en à gauche
        {
            action.next =  "ew-resize";
            action.top = false;
            action.left = true;
            action.right = false;
            action.bottom = false;

            return action;
        }

        if ((clientX >=(width-ecart)) && (clientX <=width) ) // à droite
        {
            action.top = false;
            action.left = false;
            action.right = true;
            action.bottom = false;
            action.next =  "ew-resize";
            return action;
        }


        if ((clientY >=0) && (clientY <=ecart)  ) // en haut
        {
            action.top = true;
            action.left = false;
            action.right = false;
            action.bottom = false;
            action.next =  "ns-resize";
            return action;
        }

        if ((clientY >=(height-ecart)) && (clientY <=height) ) // en bas
        {
            action.top = false;
            action.left = false;
            action.right = false;
            action.bottom = true;
            action.next =  "ns-resize";
            return action;
        }

        if ((clientX >=0) && (clientX <=width) && (clientY >=0) && (clientY <=20) ) // drag
        {
            
            action.next =  "move";
            return action;
        }
        return action;

    }

    Blocks_onBlockMouseMove(id, e)
    {

        

        if (this.state.action.current!=="none") return;

        var { clientX, clientY } = e;
        const block = this.state.blocks.find((b) => b.id === id);
        if (!block) return;

        const container = this.containerBlockRef.current;
        if (!container) return;
        const rect = container.getBoundingClientRect();

        const startX = this.convertiPourcentToPixel(block.x, rect.width);
        const startY = this.convertiPourcentToPixel(block.y, rect.height);
        const width = this.convertiPourcentToPixel(block.width, rect.width);
        const height = this.convertiPourcentToPixel(block.height, rect.height);

        // on cherche si on a un cas qui va
        

        clientX = clientX - startX - rect.left;
        clientY = clientY - startY - rect.top;

        var action = this.Blocks_GetAction(clientX,clientY,width,height);
        if (action.next !=="")
        {
            e.stopPropagation();
            e.preventDefault();
            container.style.cursor = action.next;
            action.blockid = id;
            this.setState({action: action});
            return;

        }
        else
            container.style.cursor = "default";

        
    }



    
    // *************************************************************************************************************
    // On test si le subtitle file exists
    // *************************************************************************************************************
    //this.V2_LastTranscriptSubtileComputeSubtitle = 0; // Derniere transcription utilisé le pour calcul de sous-titre
    //this.TranscriptionisModifiedForSubtitle = false; // transcription modifiée mais non calculé
    //this.V2_ComputeSubtitleInProgress = false;
    //this.V2_SaveSubtitleInProgress = false;

    V2_onCreateNewStFileStDone(ret)
    {
        this.V2_SaveSubtitleInProgress = false;
        if (ret.ret)
        {
          // ici on a créer un nouveau fichier de sous titre
          this.currentCalculedSubtitlesId = ret.id;
          
          
          // on met à jour le media asset....
          if ( (this.assetsManagerRef)&&(this.assetsManagerRef.current) )
            {
                
              
              this.assetsManagerRef.current.setNewCurrent(
                {
                    video: this.currentVideoId,
                    originaltr: this.currentOriginalTranscriptId,
                    correctedtr: this.currentCorrectedTranscriptId,
                    calculatedsubtitles: this.currentCalculedSubtitlesId,
                    correctedsubtitle: 0,
                    finaltr: 0,                    
                    sequences: this.currentSequencesId,
                }
              );
              this.assetsManagerRef.current.reloadAllAssets();
                  
            }
            // on informe la time line

            if ( (this.timelineRef)&&(this.timelineRef.current) )
            {
                const indexst = this.timelineRef.current.getIndexByType("st");
                if (indexst !== -1)
                  this.timelineRef.current.setNewId (indexst, this.currentCalculedSubtitlesId)
                else
                {
                  if (indexst === -1)
                    this.timelineRef.current.addTrack ("st",[], "subtitles", "",0,this.currentCalculedSubtitlesId);
            
                }
                
            }
            apiSearchAssetsFromProject({pjid: this.state.pjid}, this.V2_StartComputeFirstTimeSutbtitle);
            
            
            
    


        }
        
    }

    V2_StartComputeFirstTimeSutbtitle()
    {
      
      this.TranscriptionisModified = true;
      this.TranscriptionisModifiedForSubtitle = true;

    }


    V2_GereSubtitleFiles(datas)
    {

       

       if (this.V2_ComputeSubtitleInProgress) return; // ici on est en train de recalculer
       if (this.V2_SaveSubtitleInProgress) return; // ici on est en train de sauevargder

       if (this.currentCalculedSubtitlesId < 1)
       {
          
          // pas de fichier de sous titre selectionné pour le moment
          if (this.currentCorrectedTranscriptId < 1)
          {
            
            return; // pas de fichier transcription selectionné pour l'instant
          }
          // on reagrde si on a déjà un fichier de sous-titre pour cette transcription
          const  assetranscript = this.V2_GetAssetFromID(this.assetsList, this.currentCorrectedTranscriptId);
          if (assetranscript.asid < 1) 
          {
            
            return; // erreur ?
          }

          
          var idst = this.V2_CorrectedFromOriginal(this.assetsList, this.currentCorrectedTranscriptId, 4)    ; // 4 = type st calculé
          
          if (idst < 1)
          {

              // ******************************************************************
              // pas de sous titre calculé, on va en faire 1
              // ******************************************************************
              
              this.V2_SaveSubtitleInProgress = true;

              // on va créer un nouveau fichier de sous-titre

              var currentComputedSubtilesJSON = [];
              currentComputedSubtilesJSON.subtitles = {} ; // datas;
              currentComputedSubtilesJSON.asset = this.V2_GetAssetFromID(this.currentCalculedSubtitlesId);
              currentComputedSubtilesJSON.params = this.state.stparams;
              currentComputedSubtilesJSON.pjid = this.state.pjid;
              currentComputedSubtilesJSON.appInfos = this.state.appInfos;

              

              const datasst = JSON.stringify(currentComputedSubtilesJSON)
              var asfile = this.generateUUID();

              const memoryFile = new File([datasst], asfile + ".json", 
                {
                  type: "application/json", // MIME type for JSON
                  lastModified: new Date().getTime() // Timestamp for the file
                });            
              const formulaire  = 
              {
                  asid: 0,
                  uploadfile: memoryFile,
                  aspjid: this.state.pjid,
                  astype: 4, // sout-titre calculé
                  asviid: assetranscript.asviid,
                  asoriid: this.currentCorrectedTranscriptId,
                  astitle: assetranscript.astitle,
                  asfile: this.generateUUID(),
                  originalfile: "",
                  aslang: assetranscript.aslang,
                  asext: "json",
                  assubtype: 0,
                  ascreatedate: this.getCurrentDate(),
                  asupdatedate: this.getCurrentDate(),
                  asframerate: assetranscript.asframerate,
                  asnum:assetranscript.asnum,
                  asden:assetranscript.asden,
                  asdropframe: assetranscript.asdropframe,
                  astimecode: assetranscript.astimecode,
                  ascoid: assetranscript.ascoid,
              }



              if ((UploadComponentRef) && (UploadComponentRef.current))
              {
                
                UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 3 ,this.V2_onCreateNewStFileStDone);
              }
              else
                this.V2_SaveSubtitleInProgress = false;
              this.forceSave = true;              
          }
          else
          {
              // ici on a déjà un fichier de sous titres qui existe
              


          }
       }

    }


    // *************************************************************************************************************
    // Nouvelle gestion d'ouverture de transcription (diverses functions)
    // *************************************************************************************************************

    V2_FirstDownloadProjectAssets()
    {
      if (this.V2_FirstassetsDownloaded) return;

      
      
      var emptyTranscriptOriginal = []
      if ((this.transcriptRef) && (this.transcriptRef.current))
        this.transcriptRef.current.setOriginalTranscription(emptyTranscriptOriginal,0,-1,"*","*");
      var emptyTranscriptCorrected = []
      if ((this.transcriptRef) && (this.transcriptRef.current))
        this.transcriptRef.current.setTranscription(emptyTranscriptCorrected,0,-1,"*","*",'fr');
      




      if (this.state.pjid !== 0)
        apiSearchAssetsFromProject({pjid: this.state.pjid}, this.V2_OpenFirstTranscription); // C'est le grand départ
      this.V2_FirstassetsDownloaded = true;

    }

    V2_setOriginalTranscription(id)
    {
      if (id === 0)
      {
        this.currentOriginalTranscriptId = 0;
        if ((this.transcriptRef) && (this.transcriptRef.current))
        {
          var transcription = [];
          if ((this.transcriptRef) && (this.transcriptRef.current))
          {
            this.transcriptRef.current.setOriginalTranscription(transcription,0,-1 ,"","");        
          }

          if ((this.timelineRef)&& (this.timelineRef.current))
          {
            this.timelineRef.current.deleteAssetByType("trjson");
          }
          
          
        }
        return;
      }
      var datas = {asid: id};
      apiReadOneAsset (datas, this.V2_apicallbackReadOriginal)          

    }
    V2_setCorrectedTranscription(id)
    {
      var datas = {asid: id};

      apiReadOneAsset (datas, this.V2_apicallbackReadCorrected)          
      
    }

    V2_apicallbackReadOriginal(datas)
    {
      if (datas.ret)
        {
          this.currentOriginalTranscriptId = datas.asid;
          if ((this.transcriptRef) && (this.transcriptRef.current))
          {

            // compatibilité avec ancienne version
            var alldatas = JSON.parse(datas.asdatas);
            var transcription = alldatas;
            if ("transcription" in alldatas)
            {
                
                transcription = alldatas.transcription;
            }

            
            this.transcriptRef.current.setOriginalTranscription(transcription,datas.asid,-1 ,datas.astitle,datas.asfile);        
          }

          if ((this.timelineRef) && (this.timelineRef.current))
          {
            const indextr = this.timelineRef.current.getIndexByType("trjson");

            if (this.currenttimelineparams.troriginaltr)
            {
              if (indextr == -1)
                this.timelineRef.current.addTrack ("trjson",transcription, datas.astitle,"",0,datas.asid);
              else
                this.timelineRef.current.setNewDatas (indextr, transcription, datas.asid);
            }

            this.currenttimelineparams.troriginaltr = true;
          }

          this.V2_SetCurrentToAssetsManager();
          

        }      
    }

    V2_apicallbackReadCorrected(datas)
    {
      
      if (datas.ret)
        {
          
          this.currentCorrectedTranscriptId = datas.asid;

          this.loadCurrentConfiguration(datas.ascoid);

            if ((this.transcriptRef) && (this.transcriptRef.current))
            {

            var speakers = [];
            // compatibilité avec ancienne version
              var alldatas = JSON.parse(datas.asdatas);
            var transcription = alldatas;
            if ("transcription" in alldatas)
            {
                transcription = alldatas.transcription;
                if ("stparams" in alldatas)
                {
                  this.state.stparams = configurations_framestotime(alldatas.stparams,datas.asnum,datas.asden,datas.asdropframe);
                  this.setState({stparams: this.state.stparams});
                  
                }
                if ("speakers" in alldatas)
                {
                  const speakerIdsOrderByAppearance = uniqBy(transcription.filter(x => x.speakerId).map((x) => x.speakerId), (x) => x);
                  const speakers = orderBy(alldatas.speakers, ['firstName', 'name']);
                  this.setState({ 
                    speakers, 
                    speakerIdsOrderByAppearance: speakerIdsOrderByAppearance.length ? speakerIdsOrderByAppearance : speakers.map(x => x.id) 
                  });
                }
            }

            if ((this.timelineRef) && (this.timelineRef.current))
                this.timelineRef.current.setParamsST(this.state.stparams);

              
              

              //this.setState({transcriptReadOnly: false})
              
              this.transcriptRef.current.setTranscription(transcription,datas.asid,-1 ,datas.astitle,datas.asfile, datas.aslang);        
              const indextr = this.timelineRef.current.getIndexByType("newtrjson");
              // on ajoute la piste de transcription si elle n'existe pas

              if (this.currenttimelineparams.trcorrectedtr)
              {
                  if (indextr == -1)
                    this.timelineRef.current.addTrack ("newtrjson",transcription, "NEW","",0,this.currentCorrectedTranscriptId);
                  else
                    this.timelineRef.current.setNewDatas (indextr, transcription, this.currentCorrectedTranscriptId);
              }      
              this.currenttimelineparams.trcorrectedtr = true;

              const indexst = this.timelineRef.current.getIndexByType("st");
      
              // on ajoute la piste de sous-titre si elle n'existe pas
              if (indexst === -1)
                this.timelineRef.current.addTrack ("st",[], "subtitles", "",0,this.currentCalculedSubtitlesId);

              if (this.currentCalculedSubtitlesId == 0)
              {
                this.V2_GereSubtitleFiles(transcription); 
                this.TranscriptionisModifiedForSubtitle = true;
              }
              else
              {
                

                // ici on va relire le fichier des sous titres précédent pour récuperer les paramètres
                apiReadOneAsset ({asid: this.currentCalculedSubtitlesId}, this.V2_ReadCorrectedSubtitlesCallBack);

              }


              if (!"viid" in this.state.timecodeAsset)
              {
                this.setState({timecodeAsset:
                  {
                    asid: datas.asid,
                    asnum: datas.asnum,
                    asden: datas.asden,
                    asframerate: datas.asframerate,
                    asdropframe: datas.asdropframe,
                    astimecode: datas.astimecode,
                  }
                })
              }


              
                      
              
            }

            this.V2_SetCurrentToAssetsManager();
            

        }      
    }

    V2_ReadCorrectedSubtitlesCallBack(datas)
    {
      
      if (datas.ret===1)
      {
        const subtitlesdatas = JSON.parse(datas.asdatas)
        
        if ('params' in subtitlesdatas)
        {
          const params = subtitlesdatas.params;
          if ((this.appsettingsRef) && (this.appsettingsRef.current))
            this.appsettingsRef.current.setNewStParams(params)

          this.state.stparams = params;
          this.setState({stparams:this.state.stparams})
          this.TranscriptionisModifiedForSubtitle = true;


        }
      }
      
      
    }

  getCurrentValueByType(type)
  {
      switch (type)
      {
        case 1: return getAssetColorsByType("trjson");
        case 2: return getAssetColorsByType("newtrjson");
        case 3: return getAssetColorsByType("video");
        case 4: return getAssetColorsByType("oldst");
        case 5: return getAssetColorsByType("st");
        case 6: return getAssetColorsByType("finaltrjson");
        case 7: return getAssetColorsByType("voiceover");
        case 8: return getAssetColorsByType("sequences");
      }

  }


    V2_SetCurrentAssetToBlock(blocks)
    {
      blocks.forEach ((block, index) => {
          block.span=(<></>)
          switch (block.id)
          {
                case "transcription":
                  var tr = this.currentCorrectedTranscriptId;

                  if (tr <=0) tr = this.currentOriginalTranscriptId;
                  if (tr >0)
                  {
                      const as = this.V2_GetAssetFromID(this.assetsList, tr);
                      
                      if (as.asid > 0)
                      {
                        
                        const colors = this.getCurrentValueByType(as.astype);
                        var originale = (<></>)
                        if ((as.assubtype === 1) || (as.assubtype === 2))
                        {
                          const ti = as.assubtype===1?"Simp.":"Sce.";
                          originale = (<>&nbsp;<span style={{borderStyle:"solid",borderColor:"gray",borderWidth:"1px",fontSize:"10px", paddingRight: "3px", paddingLeft: "3px", borderRadius: "3px", color:"white",backgroundColor:"black"}}>{ti}</span></>)
                        }
                        
                        block.span = (<><span style={{fontSize:"10px", paddingRight: "3px", paddingLeft: "3px", borderRadius: "3px", color:colors.color,backgroundColor:colors.backcolor}}>{tr}</span>&nbsp;{originale}&nbsp;{as.astitle}</>);    
                      }
                  }
                  break;
                case "player":
                    if (this.currentVideoId>0)
                    {
                        const colors = this.getCurrentValueByType(3);
                        block.span = (<><span style={{fontSize:"10px", paddingRight: "3px", paddingLeft: "3px", borderRadius: "3px", color:colors.color,backgroundColor:colors.backcolor}}>{this.currentVideoId}</span>&nbsp;{this.state.videoname}</>);    
                    }

                  break;
                case "timeline":
                
                  block.span = (<span className={styles.apptitletimeline}>{getCurrentProjectDatas().pjorititle}</span>);    
               
                  break;
                case "speakers":
                    block.span = (<span className={styles.apptitletimeline}>Speakers</span>);    
                  break;
                case "sequences":
                  if (this.currentSequencesId>0)
                  {
                      const colors = this.getCurrentValueByType(8);
                      block.span = (<><span style={{fontSize:"10px", paddingRight: "3px", paddingLeft: "3px", borderRadius: "3px", color:colors.color,backgroundColor:colors.backcolor}}>{this.currentSequencesId}</span>&nbsp;{this.state.sequencesasset.astitle}</>);    

                  }
                  else
                    block.span = (<span className={styles.apptitletimeline}>Séquences</span>);    
                  break;
          } 
      })
      return blocks;
    }


    V2_SetCurrentToAssetsManager()
    {
      if ((this.assetsManagerRef)&&(this.assetsManagerRef.current))
        {
          this.assetsManagerRef.current.setNewCurrent(
          {
            video: this.currentVideoId,
            originaltr: this.currentOriginalTranscriptId,
            correctedtr: this.currentCorrectedTranscriptId,
            calculatedsubtitles: this.currentCalculedSubtitlesId,
            correctedsubtitle: 0,
            finaltr: 0,                    
            sequences: this.currentSequencesId,
        })
        }


      this.setState ({blocks: this.V2_SetCurrentAssetToBlock(this.state.blocks)});

    }

    



    //  **********************************************************************
    //  * Fin de creation d'un assets from un assets
    //  **********************************************************************
    V2_apiCallBackCopyToNewCorrectedTranscription(datas)
    {
        // ici on a créé une nouvelle transcription
        if ((this.assetsManagerRef)&&(this.assetsManagerRef.current))
        {
            
            if (datas.ret)
            {
              this.currentCorrectedTranscriptId = datas.id;
              this.assetsManagerRef.current.setNewCurrent(                {
                video: this.currentVideoId,
                originaltr: this.currentOriginalTranscriptId,
                correctedtr: this.currentCorrectedTranscriptId,
                calculatedsubtitles: this.currentCalculedSubtitlesId,
                correctedsubtitle: 0,
                finaltr: 0,                    
                sequences: this.currentSequencesId,
                });


            // on regarde si on a un fichier de sous-titre ou si on en crait un
        
            this.assetsManagerRef.current.reloadAllAssets();
              apiSearchAssetsFromProject({pjid: this.state.pjid}, this.V2_SetNewTranscriptionCorrected);
            }
        }
    }

    V2_SetNewTranscriptionCorrected(datas)
    {
        
        // ici on vient de créer une nouvelle transcription et recharger la liste
        this.V2_setCorrectedTranscription(this.currentCorrectedTranscriptId);
        


        this.TranscriptionisModifiedForSubtitle = true;
        this.TranscriptionisModified = true;


  }



    V2_GetAssetFromID(assets, id)
    {
      if (id < 1) return {asid:0};
      for (var i=0; i<assets.length; i++)
        if (assets[i].asid === id) return assets[i];
      return {asid:0};

    }

    V2_ExistAsset (assets, id)
    {
        if (id < 1) return false;
        for (var i=0; i<assets.length; i++)
          if (assets[i].asid === id) return true;
        return false;
    }

    V2_CorrectedFromOriginal(assets, original, type)
    {
      console.log("recherche transcription type", type," from ", original)
      if (original < 1) return false;
      for (var i=0; i<assets.length; i++)
        if ((assets[i].astype === type) && (assets[i].asoriid === original)) return assets[i].asid;
      return 0;
    }

    V2_SearchFirstTranscriptionByType(assets, type)
    {
      for (var i=0; i<assets.length; i++)
        if (assets[i].astype === type) return assets[i].asid;
      return 0;
    }
    V2_SearchFirstTranscriptionByTypeAndSubType(assets, type, subtype)
    {
      for (var i=0; i<assets.length; i++)
        if ((assets[i].astype === type) && (assets[i].assubtype === subtype)) return assets[i].asid;
      return 0;
    }
    V2_SearchFirstTranscriptionByTypeAndSubTypeAndParent(assets, type, subtype, parent)
    {
      for (var i=0; i<assets.length; i++)
        if ((assets[i].astype === type) && (assets[i].assubtype === subtype) && (assets[i].asoriid === parent)) return assets[i].asid;
      return 0;
    }
    // *************************************************************************************************************
    // Nouvelle gestion d'ouverture de transcription
    // *************************************************************************************************************

    restartRealoadPage()
    {
     
      setTimeout(() => {
        this.V2_FirstassetsDownloaded = false;
        this.V2_FirstDownloadProjectAssets();
      }, 1000);

        
    }

    onCreateANewTranscription()
    {
        this.setState({
          createANewTranscriptionPopup: false,
          popupText: "",
        });

      // on fait une transcription vide

      const formulaire = {

        ext: "json",
        filename:"",
        subtype:0,
        type: 2,
        title: this.context.language=="fr"?"Nouvelle transcription":"New transcription",
        language: this.context.language=="fr"?"fr":"en",
        framerate: 25,
        num: 25,
        den: 1,
        dropframe: 0,
        ascoid: getCurrentProjectDatas().pjconfig,
        timecode: "00:00:00:00",
        viid: 0,
        speakers:[],

      }


      if (this.state.videoforplayer)
      {
        formulaire.framerate = this.state.videoforplayer.viframerate;
        formulaire.num = this.state.videoforplayer.vinum;
        formulaire.den = this.state.videoforplayer.viden;
        formulaire.dropframe = this.state.videoforplayer.vidropframe;
        formulaire.timecode = this.state.videoforplayer.vitimecode;
        formulaire.viid = this.state.videoforplayer.viid;
        formulaire.title = this.state.videoforplayer.vititle;

        

      }
      else
      {
        // on recherche une video
        
        for (var i=0; (i<this.assetsList.length) && (formulaire.viid ===0); i++)
        {
          
          if (this.assetsList[i].astype === 3)
          {
              formulaire.framerate = this.assetsList[i].asframerate;
              formulaire.num = this.assetsList[i].asnum;
              formulaire.den = this.assetsList[i].asden;
              formulaire.dropframe = this.assetsList[i].asdropframe;
              formulaire.timecode = this.assetsList[i].astimecode;
              formulaire.viid = this.assetsList[i].asviid;
              formulaire.title = this.assetsList[i].astitle;

          }
        }
      }


      var stparams = configurations_framestotime(this.state.defaultsparams, formulaire.num, formulaire.den, formulaire.dropframe);
      
      // $$$
      stparams.num = formulaire.num;
      stparams.den = formulaire.den;
      stparams.dropframe = formulaire.dropframe;
      this.setState({stparams:  stparams});

      if ((this.appsettingsRef) && (this.appsettingsRef.current))
          this.appsettingsRef.current.setNewStParams(stparams)
      
      const jsondatas = {
        transcription: [],
        version: getCurrentVersion(),
        stparams: stparams,
      }

      const memoryFile = new File([JSON.stringify(jsondatas)], "", 
      {
      type: "application/json", // MIME type for JSON
      lastModified: new Date().getTime() // Timestamp for the file
      });

      formulaire.uploadfile = memoryFile;


      

      //$$$
      //this.TranscriptionisModified = true;
      UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 1,this.restartRealoadPage);    


    }
    returnToMainPage()
    {
        this.setState({
          createANewTranscriptionPopup: false,
          popupText: "",
        });
        SideBarRef.current.gotoRoute("localprojects");
    }

    V2_OpenFirstTranscription(datas)
    {
        
        
        this.assetsList = datas; // viennent de V2_FirstDownloadProjectAssets

        // test si il y une transcription
        

      

      const t1 = this.V2_SearchFirstTranscriptionByType (this.assetsList, 1);
      const t2 = this.V2_SearchFirstTranscriptionByType (this.assetsList, 2);
      
      if ((t1 < 1) && (t2 < 1))
      {


        // ici on a aucune transcription, on charge la configuration du projet si elle existe
        const nuconf = getCurrentProjectDatas().pjconfig;
        if (nuconf > 0)
            this.loadCurrentConfiguration (nuconf);




        this.setState({
          createANewTranscriptionPopup: true,
          popupText: {
            "fr":"Ce projet ne contient aucune transcription. Voulez vous créer une nouvelle transcription ?",
            "en": "This project does not contain any transcripts. Do you want to create a new transcript?"
          }
        })
        return;
      }
      this.checkOpenFirstVideo();
      this.V2_OpenTranscription(0,0,0);
    }



    V2_OpenTranscription(originalTranscription, correctedTranscription, generateSutbtiles)
    {
        if ((this.TranscriptionisModified) && (this.currentCorrectedTranscriptId > 0))
            this.V2_SaveCurrentTranscription (originalTranscription, correctedTranscription, generateSutbtiles, this.V2_PrepareToOpenTranscription);
        else
          this.V2_PrepareToOpenTranscription(originalTranscription, correctedTranscription, generateSutbtiles)
    }

    // *************************************************************************************************************
    // Sauvegarde de la transcription en cours
    // *************************************************************************************************************
    V2_SaveCurrentTranscription (originalTranscription, correctedTranscription, generateSutbtiles, callback)
    {
        if (callback !== null) callback(originalTranscription, correctedTranscription, generateSutbtiles)
    }


    V2_PrepareToOpenTranscription(originalTranscription, correctedTranscription, generateSutbtiles)
    {

      // Il ne peut y avoir qu'une nouvelle valeur à la fois

      

      
      this.TranscriptionisModified = false;

      // cas particulier ou il n'y a rien a faire
      if ((originalTranscription === this.currentOriginalTranscriptId) &&
          (correctedTranscription === this.currentCorrectedTranscriptId) &&
          (generateSutbtiles === this.currentCalculedSubtitlesId) &&
          (originalTranscription !==0 ) && (correctedTranscription !==0) && (generateSutbtiles !==0))
      {
          
        
          return; // rien ne bouge
      }

      // cas particulier ou tout commence
      if ((originalTranscription<1) && (correctedTranscription < 1) && (generateSutbtiles < 1))
      {
          

          // on cherche d'abord une transcription originale venant de la simplification
          originalTranscription = this.V2_SearchFirstTranscriptionByTypeAndSubType (this.assetsList, 1,1);
          if (originalTranscription < 1)
            originalTranscription = this.V2_SearchFirstTranscriptionByTypeAndSubType (this.assetsList, 1,2); // scenario ?
          if (originalTranscription < 1)
            originalTranscription = this.V2_SearchFirstTranscriptionByTypeAndSubType (this.assetsList, 1,0); // transcription ?

          // alert(originalTranscription)
          
          if (originalTranscription < 1)
            correctedTranscription = this.V2_SearchFirstTranscriptionByTypeAndSubType(this.assetsList,2);

          if ((originalTranscription < 1) && (correctedTranscription < 1))
            return; // On peut pas faire de miracles, il n'y a rien a corriger
      }

      if ((originalTranscription > 0) && (correctedTranscription < 1) && (generateSutbtiles < 1))
      {
          var originalTranscriptionTemp = 0;
          // on regarde si on a une transcription avec une simplification en enfant
          
          originalTranscriptionTemp = this.V2_SearchFirstTranscriptionByTypeAndSubTypeAndParent (this.assetsList, 1,1, originalTranscription); 
          
          if (originalTranscriptionTemp == 0) // on regarde si on a un scenario
          {
            originalTranscriptionTemp = this.V2_SearchFirstTranscriptionByTypeAndSubTypeAndParent (this.assetsList, 1,2, originalTranscription); // scenario ?  
            if (originalTranscriptionTemp >0 ) // ici on a un scenario, on regarde si on a une simplification
            {
               const originalTranscriptionTemp2 = this.V2_SearchFirstTranscriptionByTypeAndSubTypeAndParent (this.assetsList, 1,1, originalTranscriptionTemp); 
               if (originalTranscriptionTemp2 !==0 ) originalTranscriptionTemp = originalTranscriptionTemp2;
            }
          }

          if (originalTranscriptionTemp !== 0) originalTranscription = originalTranscriptionTemp;

      }      

      // on verifie que tout ça existe bien

      if (!this.V2_ExistAsset (this.assetsList, originalTranscription)) originalTranscription = 0;
      if (!this.V2_ExistAsset (this.assetsList, correctedTranscription)) correctedTranscription = 0;
      if (!this.V2_ExistAsset (this.assetsList, generateSutbtiles)) generateSutbtiles = 0;
      
      console.log("stade 1")
      console.log(originalTranscription,correctedTranscription,generateSutbtiles)

      if (originalTranscription !== 0)
      {
          // on a sélectionner une nouvelle original tanscription
          
          correctedTranscription = this.V2_CorrectedFromOriginal(this.assetsList, originalTranscription, 2); 
          console.log("stade 1a")
          console.log(originalTranscription,correctedTranscription,generateSutbtiles)

          if (correctedTranscription > 0)
          {
            generateSutbtiles = this.V2_CorrectedFromOriginal(this.assetsList, correctedTranscription, 4); 
          }
      }
      else
        if (correctedTranscription !== 0)
          {
              // on a sélectionner une nouvelle original tanscription
              
              var asset = this.V2_GetAssetFromID(this.assetsList,correctedTranscription);
              if ((asset.asid >0) && (this.V2_ExistAsset(this.assetsList,asset.asoriid)))
                originalTranscription = asset.asoriid;
              else
                originalTranscription = 0;
              // on regarde si on a déja des sous titres
              generateSutbtiles = this.V2_CorrectedFromOriginal(this.assetsList, correctedTranscription, 4); 

          }
        else
          return; // on peut rien charger pour l'instant
  


      console.log("stade 10")
      console.log(originalTranscription,correctedTranscription,generateSutbtiles)
      
      

      this.currentCalculedSubtitlesId = generateSutbtiles;
      if (originalTranscription > 0) this.V2_setOriginalTranscription(originalTranscription);
      if (correctedTranscription > 0) this.V2_setCorrectedTranscription(correctedTranscription);

      if (originalTranscription === 0)
        this.V2_setOriginalTranscription(0);



      // Faut t'il créer une transcription corrigée à partir de l'originale
      if ((correctedTranscription <1) && (originalTranscription>0))
      {
          // on peut en créer une à partir de l'original
          const pjid = getCurrentProjectDatas().pjid;
          var originalasset = this.V2_GetAssetFromID(this.assetsList, originalTranscription)
          var datas  = 
          {
            asid: 0,
            aspjid: pjid,
            astype: 2, // transcription corrigée
            asviid: originalasset.asviid,
            asoriid: originalTranscription, // transcription originale
            astitle: originalasset.astitle,
            asfile: this.generateUUID(),
            originalfile: originalasset.asfile,
            aslang: originalasset.aslang,
            asext: originalasset.asext,
            assubtype: originalasset.assubtype,
            ascreatedate: this.getCurrentDate(),
            asupdatedate: this.getCurrentDate(),
            asframerate: originalasset.asframerate,
            asnum: originalasset.asnum,
            asden: originalasset.asden,
            asdropframe: originalasset.asdropframe,
            astimecode: originalasset.astimecode,
            ascoid: originalasset.ascoid,
          }

          this.state.stparams = configurations_framestotime(this.state.stparams,originalasset.asnum, originalasset.asden, originalasset.asdropframe);
          this.setState({stparams: this.state.stparams});
          console.log("creation d'un transcription with ", datas)
          apiCreateFromAsset(datas, this.V2_apiCallBackCopyToNewCorrectedTranscription)

      }
    }


    // *********************************************************************
    // * demmarrer avec une nouveelle vidéo
    // ********************************************************************

    addTrackAudio(video)
    {
      if ((this.timelineRef) && (this.timelineRef.current))
      {

          if (this.currenttimelineparams.trtrackaudio)
          {
              const audiofile1 = getAudioPath(1, video);
              if (audiofile1 !=="") this.timelineRef.current.addTrack ("mp4zaudio",null, audiofile1,"",1, this.currentVideoId);
              const audiofile2 = getAudioPath(2, video);
              if (audiofile2 !=="") 
                this.timelineRef.current.addTrack ("mp4zaudio",null, audiofile2,"",2, this.currentVideoId);

              if (this.currenttimelineparams.trsmalltrackaudio)
                this.timelineRef.current.minimiseTrack("mp4zaudio");

          }

          this.currenttimelineparams.trtrackaudio = true;
          this.currenttimelineparams.trsmalltrackaudio = false;
          
      }
    }

    addTrackCp(video)
    {
      if ((this.timelineRef) && (this.timelineRef.current))
      {
          const cpfiles = getCpPaths(video);
          if (this.currenttimelineparams.trtrackcp)
          {
            this.timelineRef.current.addTrack ("mp4zcp",video, cpfiles.json,cpfiles.jpegs,0, this.currentVideoId);
            if (this.currenttimelineparams.trsmalltrackcp)
              this.timelineRef.current.minimiseTrack("mp4zcp")
          }
          this.currenttimelineparams.trtrackcp = true;
          this.currenttimelineparams.trsmalltrackcp = false;


      }
    }

    checkOpenFirstVideo()
    {
      if (this.currentVideoId !=0) return;
      this.currentVideoId = 0;
      for (var i=0; (i<this.assetsList.length) && (this.currentVideoId ===0); i++)
      {
        if (this.assetsList[i].astype === 3)
        {
            this.currentVideoId = this.assetsList[i].asviid;
            
            this.setNewVideoAsset(this.currentVideoId);
        }
      }

    }
    closeCurrentVideo()
    {
      this.setState({videopath: "", videoready: false, videoforplayer: null})
    }

    apicallbackReadVideo(datas)
    {
        
        if (datas.length > 0)
        {


          this.sequences_start_with_first_sequence(datas[0].viid);

          const framerate = datas[0].viframerate.toFixed(2).replace('.', ','); // "1234,56"
          const num = datas[0].vinum;
          const den = datas[0].viden;
          const dropframe = datas[0].asdropframe;

          
            const video = datas[0];
            const videofile = getVideoPath(video);
            
            this.setState({videopath: videofile, 
              framerate: framerate,
              videoname: video.vititle,
              den: den,
              num: num,
              dropframe: dropframe,
              videoready: true, 
              timecodeAsset: video,
              videoforplayer: video});

            if ((video.vixaudio == -3) && (video.vinbaudio !==0))// on a de l'audio
            {
                this.addTrackAudio(video)

            }
            if (video.vixcp == -3 )// on a du cp bon marhé
            {
                this.addTrackCp(video)

            }

            this.assetsManagerRef.current.setNewCurrent(
              {
                  video: this.currentVideoId,
                  originaltr: this.currentOriginalTranscriptId,
                  correctedtr: this.currentCorrectedTranscriptId,
                  calculatedsubtitles: this.currentCalculedSubtitlesId,
                  correctedsubtitle: 0,
                  finaltr: 0,                    
                  sequences: this.currentSequencesId,
              }
            );
            this.assetsManagerRef.current.reloadAllAssets();

            this.V2_SetCurrentAssetToBlock(this.state.blocks);


        }
    }

    upDateAllCpForTranscription()
    {
        if ((this.transcriptRef) && (this.transcriptRef.current))
        {
            var scriptptr = this.transcriptRef.current.getTranscriptionPtr();
            this.searchAllCpForTranscription(scriptptr);
          this.transcriptRef.current.onRefreshCanvas();
        }

    }

    handleCPFileLoaded (cplist)
    {
        this.state.stparams.cplist = cplist;
        this.state.stparams.cplistinverse = cplist.slice().reverse();
        this.upDateAllCpForTranscription();

    }

    setNewVideoAsset (viid)
    {
      this.closeCurrentVideo()
      var datas = {viid: viid};
      this.currentVideoId = viid;
      apiReadOneVideo (datas, this.apicallbackReadVideo)      
    }
    //getVideoPath


    searchAllCpForTranscription(script)
    {
        

        // supposons de script contienne tous les mots

        const indexderniermot = script.length - 1;

        var lastEndTime = 0;
        var timecode =  "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vitimecode:this.state.timecodeAsset.astimecode;
        var den = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden;
        var num = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum;
        var dropframe = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vidropframe:this.state.timecodeAsset.asdropframe;

        const timecodenum = V2_ConvertTimeCodeStringToSecond(timecode,num,den,dropframe,timecode);
        
        script.forEach(( word, index) =>{


          word.cpbefore = false;
          word.cpafter = false;
          word.cpinside = false;


          // 

          // étape 1 : on regarde si il y un cp entre startTime et endTime précédent
          const cpbeforefromstart  = globalFindCpBefore(word.startTime - timecodenum, this.state.stparams.cplistinverse);

          if ((cpbeforefromstart !== null ) && (cpbeforefromstart.time > lastEndTime))
          {
              
              word.cpbefore = true;

              if (index !== 0)
                if ((word.newline) || (word.markWord & 2))
                  script[index-1].cpafter = true;
          }

          // étape 2 : on regarde si il y un cp entre startTime et endTime 
          const cpafterfromstart  = globalFindCpAfter(word.startTime - timecodenum , this.state.stparams.cplist);

          if ((cpafterfromstart !== null) && (cpafterfromstart.time <(word.endTime - timecodenum)))
          {
            
            word.cpinside = true;
          }


          // etape 3 : Seulement sur le dernier mot
          // on regarde si on a un cp après endtime
          if (index === indexderniermot)
          {
            const cpafterfromend  = globalFindCpAfter(word.endTime - timecodenum, this.state.stparams.cplist);
            if (cpafterfromend !== null)
            {
              
              word.cpafter = false;
            }
          }

          // pour la suite...
          lastEndTime = word.endTime - timecodenum;

        });

        


    }

handleOnMustReload(button, datas)
{
  

  if (button !=="ok") return;
  if (!datas.apply) {
    this.props.onnavigate("transcription");
    return; // on fait rieness
  }

  
  this.saveTranscription();
  this.setState({displayApplyOffset: true, ApplyOffsetDatas: datas})
}

handleEndApplyVideo(buttons)
{
  this.setState({displayApplyOffset: false});
  
  this.props.onnavigate("transcription");
}



//  ***********************************************************************************
//  * Gestion des séquences
//  ***********************************************************************************

doActionSequence (action, sequence, sequenceId, time, timelinetime,cpbefore, cpafter, maxduration)
{

  switch (action)
  {
    case "SETTCIN":
      this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId-1].out = timelinetime;
      sequences.sequences[sequenceId].in = timelinetime;
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;

    case "SETTCOUT":
      this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId+1].in = timelinetime;
      sequences.sequences[sequenceId].out = timelinetime;
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;

    
    case "SETTCINSHOT":
      
      if (cpbefore === -1) break;
      this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId-1].out = cpbefore;
      sequences.sequences[sequenceId].in = cpbefore;
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;




      case "SETTCOUTSHOT":
        
        if (cpafter === -1) break;
        this.sequences_add_one_undo();
        var sequences = cloneDeep(this.state.sequences);
        sequences.sequences[sequenceId+1].in = cpafter;
        sequences.sequences[sequenceId].out = cpafter;
        this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
        this.setState ({sequences: sequences})
        if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
        break;
    

    case "EXTEND":
     this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId].out = maxduration;
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;
            
    case "INSERT":
     this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);

      const tcin = time;
      const tcout = sequences.sequences[sequenceId].out;
      sequences.sequences[sequenceId].out = time;
      var newsequence = sequencesCreateDefaultSequenceV2(tcin, tcout)
      sequences.sequences.splice(sequenceId+1, 0, newsequence);
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();

      break;


    case "DELETEWITHPREVIOUS":
      this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId-1].out = sequences.sequences[sequenceId].out;
      sequences.sequences.splice(sequenceId,1);
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;


    case "DELETEWITHNEXT":
      this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId+1].in = sequences.sequences[sequenceId].in;
      sequences.sequences.splice(sequenceId,1);
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;
  }

}
onClickOnSequence(sequence, movevideo)
{
  if ((this.sequencesRef) && (this.sequencesRef.current))
    return this.sequencesRef.current.gotoSequence(sequence.sequenceId, movevideo);
  return false;
}

sequences_createsequences()
{
  if (this.state.videoforplayer)  
  {
    this.sequences_save_sequences();
    const datas = {
      viid: this.state.videoforplayer.viid,
      pjid: this.state.pjid,
      ascreatedate: this.getCurrentDate(),
      asupdatedate: this.getCurrentDate(),
      asfile:this.generateUUID(),
      asext: "json",
    }
    
    apiCreateSequences(datas, this.sequences_createsequences_callback);
  }
}
sequences_createsequences_callback(datas)
{
    
    if (datas.ret)
    {
      this.assetsManagerRef.current.reloadAllAssets();
      this.sequences_setSequences(datas.asid);
    }
}

sequences_setSequences(sequencesId)
{

    var datas = {asid: sequencesId};
    apiReadOneAsset (datas, this.sequences_setsequences_callback)          
}

sequences_start_with_first_sequence(viid)
{
    // on cherche le premier fichier de séquences disponible
    if (this.currentSequencesId <1)
    {

      var asid = 0;
      // on cherche d'abord avec la video
      for (var i=0; i<this.assetsList.length && asid===0; i++)
        if ((this.assetsList[i].astype === 8) && (this.assetsList[i].asoriid === viid)) asid = this.assetsList[i].asid;

      if (asid ===0)      
      {
        // sans vidéo
        for (var i=0; i<this.assetsList.length && asid===0; i++)
          if (this.assetsList[i].astype === 8)  asid = this.assetsList[i].asid;

      }
      if (asid !==0)      
      {
        const asset = this.V2_GetAssetFromID(this.assetsList, asid);
        if (asset.asid > 0)
            this.sequences_setSequences(asid);
      }
    }

}

sequences_save_sequences()
{
  if (this.sequencesRef && this.sequencesRef.current && this.sequencesRef.current.getSequencesModified()) 
  {
    this.sequencesRef.current.clearSequencesModified();
    // sauvegarde des séquences
    
    var towrite = 
    {
      
      den: this.state.sequencesasset.asden,
      num: this.state.sequencesasset.asnum,
      timecode: this.state.sequencesasset.astimecode,
      framerate: this.state.sequencesasset.asframerate,
      pjid: this.state.pjid,
      version: getSequenceVersionFile(),
      sequences: this.state.sequences.sequences,
    }
    

    const memoryFileSequence = new File([JSON.stringify(towrite)], this.state.sequencesasset.asfile + "." +this.state.sequencesasset.asext, 
      {
      type: "application/json", // MIME type for JSON
      lastModified: new Date().getTime() // Timestamp for the file
      });            
      if ((UploadComponentRef) && (UploadComponentRef.current))
      {
        const formulaire = {
          asid: this.state.sequencesasset.asid,
          aspjid: this.state.pjid,
          astype: 8,
          uploadfile: memoryFileSequence,
          filenamedest: this.state.sequencesasset.asfile + "." +this.state.sequencesasset.asext,
          filenamesource: this.state.sequencesasset.asfile,
          asupdatedate: this.getCurrentDate(),
          
        }
        
        UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 2 ,null);
      }
      
  }
  this.sequencesModified = false;

}


sequences_check_sequences(sequences)
{

  
  
  if (!("sequences" in sequences))
    sequences.sequences = [];

  if (sequences.sequences.length === 0)
  {
    
    // premier utilisation des sequences

    var start = 0;
    var end = 0;
    if (this.state.videoforplayer)
    {
      this.sequencesModified = true;
      start = V2_ConvertTimeCodeStringToSecondFromAsset(this.state.videoforplayer.vitimecode,this.state.videoforplayer);
      const duration = V2_ConvertTimeCodeStringToSecondFromAsset(this.state.videoforplayer.viduration,this.state.videoforplayer);
      end = start + duration;
    }
    else
    {
      start = 0;
      end = start + 60 * 60 * 24;
    }

    sequences.sequences.push(sequencesCreateDefaultSequenceV2(start,end));

  }
  else
  {
      sequences = createV2SequencesFiles(sequences);

  }

  
  return sequences;
}


sequences_add_one_undo()
{
  if (this.undosequences.length >= this.maxUndoSequences)
    this.undosequences.shift();
  this.undosequences.push(structuredClone(this.state.sequences.sequences))
  
}

sequences_setsequences_callback(datas)
{
    
    this.undosequences = [];
    
    if (datas.ret == 1)
    {

      
      const sequences = this.sequences_check_sequences (JSON.parse(datas.asdatas));
      var sequencesasset = cloneDeep(datas);
      delete sequencesasset.asdatas;

      this.currentSequencesId = sequencesasset.asid;
      this.V2_SetCurrentToAssetsManager();

      this.sequences_add_sequences_track (sequencesasset, sequences);
      this.setState ({sequences: sequences, sequencesasset: sequencesasset})
      
      this.disableOptionInToolBar("sequencesplus", true);
      this.disableOptionInToolBar("addsequence", false);
      this.disableOptionInToolBar("deletesequencebefore", false);
      this.disableOptionInToolBar("deletesequenceafter", false);
      this.disableOptionInToolBar("undosequence", false);
      
    }
}

sequences_onChangeSequences(sequence, sequenceNumber)
{

  var newsequences = cloneDeep(this.state.sequences);
  newsequences.sequences[sequenceNumber] = sequence;

  this.sequences_add_one_undo()
  
  this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), newsequences)
  this.setState({sequences: newsequences})


}

sequences_add_sequences_track (asset, sequences)
{
    const indexseq = this.timelineRef.current.getIndexByType("sequences");
    // on ajoute la piste de sequences si elle n'existe pas
    if (indexseq == -1)
      this.timelineRef.current.addTrack ("sequences",sequences, asset,null,0, asset.asid);
    else
    {
      this.timelineRef.current.setNewDatas (indexseq, sequences, 0, asset);
    }

}

sequences_goto (timecode)
{
    if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
        this.videoPlayerRef.current.goto(timecode);

}

sequences_onGetText(tcin, tcout, sequenceindex = 0)
{
  var scriptptr = this.transcriptRef.current.getTranscriptionPtr();

  var script = "";
  
  if (scriptptr)
  {
    const nbwords  = scriptptr.length;
    
    var firstindex = -1;
    // on recherche le premier mot au time code
    if (sequenceindex === 0)
    {
      for (var i=0; i < nbwords && firstindex === -1; i++)
      {
        if (scriptptr[i].startTime >= tcin)
          firstindex = i;
      }
    }
    else
    {
      // pour les sequences suivants, il faut un retour ligne
      for (var i=0; i < nbwords && firstindex === -1; i++)
      {
        if ((scriptptr[i].startTime >= tcin) && (scriptptr[i].newline))
          firstindex = i;
      }

    }
    if (firstindex === -1) return script;
    if ((firstindex !== 0) && (!scriptptr[firstindex].newline))
    {
      // on recherche le début réel de la ligne
      while ((firstindex !== 0) && (!scriptptr[firstindex].newline))
        firstindex--;
    }
    // on recherche la fin du texte
    script = scriptptr[firstindex].text;

    firstindex++
    while (firstindex < nbwords)
    {
      if (!scriptptr[firstindex].newline)
        script = script + " " + scriptptr[firstindex].text;
      else
      {
        if (scriptptr[firstindex].startTime >= tcout)
          firstindex = nbwords;
        else
          script = script + "\n" + scriptptr[firstindex].text;

      }
      firstindex++;

    }


  }

  return script;
}

// **************************************************************************************************************************************************************
// appmediaassets actions
// ***************************************************************************************************************************************************************

firstLoadConfiguration(nuconf)
{
    apiReadOneConfiguration (nuconf, this.firstLoadConfigurationDone);
}

firstLoadConfigurationDone(datas)
{
    if (datas.length > 0)
    {
        
        var stdatas = JSON.parse(datas[0].codatas);
        var defaultdatas = JSON.parse(datas[0].codatas);

        var den =  ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden);
        var num =  ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum);

        stdatas = configurations_framestotime(stdatas, den,num);

        

        this.setState ({
          codatas: datas[0],
          stparams: stdatas,
          defaultsparams: defaultdatas,    // parametres de la configuration de l'asset en cours
          refreshKey: this.getTimeHHMMSSforKey(),

        })

        this.state.stparams = stdatas;
        if ((this.appsettingsRef) && (this.appsettingsRef.current))
            this.appsettingsRef.current.setNewStParams(stdatas)
             
        this.timelineRef.current.setParamsST(this.state.stparams);
        this.timelineRef.current.forceRecreate();


        
    }

    this.V2_FirstDownloadProjectAssets();

}

loadCurrentConfiguration(nuconf)
{
    // on charge une configuration
    if (nuconf > 0)
      apiReadOneConfiguration (nuconf, this.loadCurrentConfigurationDone)
}


loadCurrentConfigurationFromAppMediaAsset(nuconf)
{
    // on charge une configuration
    if (nuconf > 0)
      apiReadOneConfiguration (nuconf, this.loadCurrentConfigurationFromAppMediaAssetDone)
}


writeCurrentConfigurationInAsset(nuconfig)
{

  if (this.currentCorrectedTranscriptId > 0)
  {
    apiSetAssetConfiguration( {asid:this.currentCorrectedTranscriptId, coid: nuconfig}, this.writeCurrentConfigurationInAssetDone)
    if (this.currentCalculedSubtitlesId > 0)
        apiSetAssetConfiguration( {asid:this.currentCalculedSubtitlesId, coid: nuconfig}, this.writeCurrentConfigurationInAssetDone)
    this.TranscriptionisModified = true;
  }
  
}

writeCurrentConfigurationInAssetDone(datas)
{
  
  if ((this.assetsManagerRef) && (this.assetsManagerRef.current))
    this.assetsManagerRef.current.reloadAllAssets();
}

loadCurrentConfigurationDone(datas)
{
  
    if (datas.length > 0)
    {
        
        this.setState ({
          codatas: datas[0],
          defaultsparams: JSON.parse(datas[0].codatas),    // parametres de la configuration de l'asset en cours
          refreshKey: this.getTimeHHMMSSforKey(),
        })
        
    }
    

}

loadCurrentConfigurationFromAppMediaAssetDone(datas)
{

    
    

    if (datas.length > 0)
    {
        
        var stdatas = JSON.parse(datas[0].codatas);
        var defaultdatas = JSON.parse(datas[0].codatas);

        var den =  ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden);
        var num =  ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum);

        stdatas = configurations_framestotime(stdatas, den,num);

        

        this.setState ({
          codatas: datas[0],
          stparams: stdatas,
          defaultsparams: defaultdatas,    // parametres de la configuration de l'asset en cours
          refreshKey: this.getTimeHHMMSSforKey(),

        })

        this.state.stparams = stdatas;
        if ((this.appsettingsRef) && (this.appsettingsRef.current))
            this.appsettingsRef.current.setNewStParams(stdatas)
             
        this.TranscriptionisModifiedForSubtitle = true;
        this.TranscriptionisModified = true;

        
        this.timelineRef.current.setParamsST(this.state.stparams);
        this.timelineRef.current.forceRecreate();


        
    }
    
}

changeBlockDisplayState(blockname)
{
  var blockid = "";
    switch (blockname)
    {
        case "displayplayer": blockid = "player"; break;
        case "displaytimeline": blockid = "timeline"; break;
        case "displayspeakers": blockid = "speakers"; break;
        case "displaysequences": blockid = "sequences"; break;
        case "displaysubtitles": blockid = "subtitles"; break;
        case "displaytranscription": blockid = "transcription"; break;

    }
    var blocks = this.state.blocks;


    blocks.forEach (block =>{
      if (block.id === blockid)
        block.visible==="visible"?block.visible="hidden":block.visible="visible";
    

    })

    this.setState({blocks:blocks});


}


onAppMediaAssetsAction(action)
{
  switch (action.source)
  {


    case "submenu":
      switch (action.submenu.key)
      {
        case "EXIT":
          if ((this.appMediaAssetsRef) && (this.appMediaAssetsRef.current))
            this.appMediaAssetsRef.current.closeAppMediaAsset();
          break;

          // zones affichées

        case "displayplayer":
        case "displaytimeline":
        case "displayspeakers":
        case "displaysequences":
        case "displaysubtitles":
        case "displaytranscription":
          this.changeBlockDisplayState (action.submenu.key);
          break;
      }
      break;
    case "ConfManager":
      switch (action.action)
      {
        case "EXIT":
          // on ferme appmediaasset
          if ((this.appMediaAssetsRef) && (this.appMediaAssetsRef.current))
            this.appMediaAssetsRef.current.closeAppMediaAsset();
          break;
        case "DELETE":
          

          var texte = {
            "fr":"Voulez vous supprimer la configuration " + action.coname,
            "en": "Do you realy want to delete the configuration " + action.coname,
          }

          this.setState({
            deleteConsfigurationPopup: true,
            deleteConfigurationId: action.coid,
            popupText: texte,
          })



          break;

        case "NEWCONFIG": // ici on a chargé une nouvelle configuration
          
          this.loadCurrentConfigurationFromAppMediaAsset(action.coid)
          this.writeCurrentConfigurationInAsset(action.coid)
          // on ferme appmediaasset
          if ((this.appMediaAssetsRef) && (this.appMediaAssetsRef.current))
            this.appMediaAssetsRef.current.closeAppMediaAsset();
          break;

      }
  }

}


onDeleteConfiguration()
{
  this.setState({deleteConsfigurationPopup:false});
  if ((this.appMediaAssetsRef) && (this.appMediaAssetsRef.current))
    this.appMediaAssetsRef.current.closeAppMediaAsset();
  if (this.state.deleteConfigurationId > 0)
  {
    apiDeleteConfiguration({coid: this.state.deleteConfigurationId}, this.onDeleteConfigurationDone);

  }

}
onDeleteConfigurationDone (datas)
{

    this.setState ({codatas: {coid:-1}, refreshKey: this.getTimeHHMMSSforKey()});
    this.assetsManagerRef.current.reloadAllAssets();
}

getTimeHHMMSSforKey() 
{
  const now = new Date();

  const hh = String(now.getHours()).padStart(2, '0');
  const mm = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');

  return hh + mm + ss;
}

}




export default AppTranscription;








